import React from 'react';
import PropTypes from 'prop-types';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var IcoMoonType = "selection";
var icons = [
	{
		icon: {
			paths: [
				"M550.2 181.4c0.6 0 1.2 0 2 0 13.4 0 26.2 2.4 38 6.6l-0.8-0.2c11.6 3.8 21.6 9.6 30.2 17.2h-0.2c8 7 14.4 15.6 18.6 25.4l0.2 0.4c4.4 9.2 6.8 19.8 6.8 31.2 0 0.2 0 0.4 0 0.8v0c0 0.4 0 1 0 1.4 0 9-1.2 17.6-3.6 25.8l0.2-0.6c-2.2 7.6-5.4 14.2-9.8 20l0.2-0.2c-4.4 5.6-9.6 10.4-15.4 14.4l-0.2 0.2c-6 3.6-13 7-20.2 9.4l-0.8 0.2c17.2 5 31.6 15 42 28.2l0.2 0.2c8.8 11.8 14 26.6 14 42.6 0 1.2 0 2.2 0 3.2v-0.2c0 0.6 0 1.4 0 2.2 0 27.8-12.4 52.8-32 69.6l-0.2 0.2c-9.8 7.8-21.2 14.2-33.6 18.2l-0.8 0.2c-12 4-25.6 6.2-40 6.2-0.4 0-1 0-1.4 0v0c-0.8 0-1.8 0-2.8 0-13.6 0-26.8-2-39.4-5.6l1 0.2c-11.8-3.8-22-9.2-31-16l0.2 0.2c-8.8-7.8-16.2-17-22-27l-0.2-0.6c-5.8-10.2-11.2-22-15.2-34.4l-0.4-1.4 23.8-9.6c3.6-1.6 7.8-2.6 12.2-2.6 0 0 0 0 0 0v0c3.8 0 7.2 0.8 10.4 2.4h-0.2c2.8 1.8 5.2 4.2 6.8 7v0c3 5.8 5.8 10.8 8.8 15.4l-0.4-0.6c3.2 5 6.8 9.4 11 13.4v0c4.4 3.6 9.4 6.8 15 9.2l0.4 0.2c6 2.2 12.8 3.4 19.8 3.4 0.4 0 0.8 0 1.2 0v0c0.4 0 1 0 1.6 0 8 0 15.8-1.6 22.8-4.8l-0.4 0.2c6.6-2.8 12.4-6.6 17-11.4v0c4.4-4.6 7.8-10 10.2-15.8l0.2-0.4c2.2-5.2 3.4-11.2 3.4-17.6v0c0 0 0 0 0-0.2 0-7.2-0.8-14.2-2.4-21l0.2 0.6c-1.8-6.4-5.4-11.8-10-16v0c-6.2-4.8-13.6-8.2-21.6-10.2h-0.4c-10.6-2.4-22.8-3.8-35.4-3.8-1 0-2 0-3 0h0.2v-38.2c0.8 0 1.8 0 2.8 0 10.6 0 21-1.2 31-3.6l-1 0.2c8-2 14.8-5.4 21-9.8l-0.2 0.2c4.8-3.8 8.6-9 10.8-14.8v-0.2c2-5.6 3.2-12 3.2-18.6 0-0.2 0-0.4 0-0.4v0c0-0.8 0-1.8 0-2.8 0-12-4.6-23-12.4-31v0c-8-6.6-18.4-10.6-29.8-10.6-1.2 0-2.4 0-3.6 0.2h0.2c-0.6 0-1.2 0-1.8 0-11.4 0-21.8 3.8-30.2 10.4h0.2c-8.2 6.6-14.4 15.4-17.6 25.6v0.4c-1.2 4.6-3.6 8.6-7 11.6v0c-3 2.4-6.8 3.8-11 3.8-0.4 0-0.6 0-1 0v0h-7.4l-28.4-5.2c1.6-15.2 6-29 12.6-41.6l-0.4 0.6c6-11.2 13.8-20.6 23.2-28.4l0.2-0.2c9.6-7.6 20.6-13.4 32.8-17.2l0.8-0.2c11.4-3.8 24.6-5.8 38.2-6v0 0z",
				"M812.4 303c0 0 0 0 0 0 12.4 0 24.4 2.2 35.4 6.2l-0.8-0.2c22.8 8.2 40.8 25.2 50.2 46.6l0.2 0.6c4.8 11.6 7.8 25 7.8 39 0 1 0 2.2 0 3.2v-0.2c0 0.2 0 0.6 0 0.8 0 14.6-3 28.4-8.2 41l0.2-0.8c-5.6 13-13 24.2-22.4 33.6v0c-9.8 9.4-21.6 17-34.6 22.2l-0.8 0.2c-12.8 5.2-27.6 8.2-43 8.2-0.8 0-1.6 0-2.2 0h0.2c-0.8 0-1.6 0-2.6 0-15.4 0-30-3-43.4-8.2l0.8 0.2c-13.4-5.4-24.8-13-34.4-22.4v0c-9.2-9.8-16.6-21.4-21.4-34.2l-0.2-0.6c-4.6-13-7.4-28-7.4-43.6 0-0.4 0-1 0-1.4v0c0.2-16.4 3.6-32 9.4-46.4l-0.4 0.8c7.8-18.6 17.4-34.6 28.8-49l-0.4 0.4 73.4-100.2c3-4 6.8-7 11.2-9h0.2c4.8-2.4 10.4-3.8 16.4-3.8 0.4 0 0.8 0 1 0v0h47.8l-99.2 120.8-5.4 6.8c12.4-6.2 27.2-9.8 42.6-10v0l1.2-0.6zM737 400.8c0 8.6 1.4 16.8 3.8 24.4l-0.2-0.6c2.4 7 6 13.2 10.6 18.2v0c4.6 5.2 10.2 9.2 16.4 12.2l0.4 0.2c6.8 2.8 14.6 4.2 22.8 4.2 0.4 0 1 0 1.4 0v0c0.4 0 0.8 0 1.2 0 8 0 15.8-1.6 22.6-4.8l-0.4 0.2c7.2-2.8 13.4-6.8 18.4-12v0c5-5.2 9-11.4 11.8-18.2l0.2-0.4c2.8-6.6 4.2-14.4 4.2-22.6 0-0.2 0-0.4 0-0.6v0c0-0.4 0-1 0-1.6 0-8-1.4-15.8-4.2-23l0.2 0.4c-2.6-7.2-6.6-13.2-11.6-18.2v0c-5-5-11.2-8.8-18.2-11.2l-0.4-0.2c-6.8-2.6-14.8-4-23-4-0.2 0-0.2 0-0.4 0v0c-0.2 0-0.4 0-0.8 0-8.2 0-16 1.6-23 4.4l0.4-0.2c-7 3-13 7.2-18 12.2v0c-5 5-9 11.2-11.6 17.8l-0.2 0.4c-2 6-3.2 13-3.2 20.2 0.8 1.4 0.8 2 0.8 2.8v0 0z",
				"M1169.4 344.4c0 1.4 0 3.2 0 5 0 23.6-3.2 46.6-9.2 68.2l0.4-1.8c-5.2 19.2-13.4 36-24.4 50.8l0.2-0.4c-9.8 12-22 21.6-36 28.2l-0.6 0.2c-13.4 6-29.2 9.6-45.8 9.6s-32.4-3.6-46.6-10l0.8 0.2c-14.6-6.8-26.6-16.4-36.2-28.2l-0.2-0.2c-10.4-14.2-18.6-30.6-23.6-48.4l-0.2-1c-5.4-20-8.6-43.2-8.6-67 0-1.6 0-3.2 0-4.8v0.2c0-1.4 0-3.2 0-4.8 0-23.6 3.2-46.6 9-68.4l-0.4 1.8c5.2-19.2 13.6-35.8 24.4-50.4l-0.2 0.4c9.6-12 21.8-21.6 35.8-28.2l0.6-0.2c13.4-6 29.2-9.6 45.8-9.6s32.4 3.6 46.6 10l-0.8-0.2c14.6 6.8 27 16.4 36.6 28.2l0.2 0.2c10.8 14.2 19 31 24 49l0.2 1c5.4 19.6 8.6 42 8.6 65.2 0 2 0 3.8 0 5.6l-0.4-0.2zM1114.2 344.4c0-1.6 0-3.4 0-5.2 0-18.4-1.8-36.2-5.4-53.4l0.2 1.6c-2.6-13.4-7.2-25.4-13.6-36l0.2 0.6c-4.8-8-11.2-14.2-19-18.6l-0.2-0.2c-5-1.8-10.8-2.8-17-2.8-2 0-3.8 0.2-5.8 0.4h0.2c-8.2 0-15.8 2-22.8 5.2l0.4-0.2c-8 4.6-14.4 11-19 18.6l-0.2 0.2c-5.6 9.6-10.2 20.6-13 32.2l-0.2 0.8c-3 15.8-4.8 33.8-4.8 52.4 0 1.6 0 3.2 0 4.8v-0.2c0 1.4 0 3 0 4.4 0 18.6 1.8 36.6 5.2 54.2l-0.2-1.8c2.8 13.4 7.2 25.2 13.4 36.2l-0.4-0.6c4.6 8 11 14.2 18.8 18.6l0.2 0.2c6.6 3.2 14.2 5.2 22.4 5.4v0c8.2-0.2 16-2 22.8-5.6l-0.4 0.2c8.2-4.4 14.8-10.8 19.2-18.6l0.2-0.2c6-10.2 10.8-22.2 13.2-34.8l0.2-0.8c3.2-15.6 5.2-33.4 5.2-51.8 0-1.8 0-3.6 0-5.4l0.2 0.2z",
				"M1195 203.6c-32 0-57.8-26-57.8-57.8 0-32 26-57.8 57.8-57.8 32 0 57.8 26 57.8 57.8s-26 57.8-57.8 57.8zM1195 110.8c-19.2 0-34.8 15.6-34.8 34.8s15.6 34.8 34.8 34.8 34.8-15.6 34.8-34.8-15.6-34.8-34.8-34.8z",
				"M657 715.4c-246.2-18.8-455-99.2-455-187.4 0-56.8 85.4-100.4 211.4-128.6v-63.2c-188.6 39-323.4 108-323.4 196.8 0 123.8 263.2 244 568.8 271.4v120.4l251.4-159.8-253.2-174.6v125z",
				"M1202 356.4v68c85.4 28.4 140 67.4 140 111.2 0 73.2-151.6 136.8-345 166.4v94.4c257.4-35.8 450.6-134 450.6-245.8 0-79.8-97.4-149-245.6-194.2v0z"
			],
			attrs: [
			],
			width: 1564,
			isMulticolor: false,
			isMulticolor2: false,
			grid: 16,
			tags: [
				"360"
			],
			colorPermutations: {
			},
			defaultCode: 59655
		},
		attrs: [
		],
		properties: {
			order: 2059,
			id: 0,
			name: "360",
			prevSize: 15,
			code: 59655,
			ligatures: "360"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M751 661.4c0.4 0 0.8 0 1.2 0 9.8 0 19.2 1.8 27.6 5.4l-0.6-0.2c16.2 5.8 28.8 18 35.2 33.4l0.2 0.4c3 7.2 4.8 15.6 4.8 24.4 0 0.4 0 0.8 0 1.2v0c0 0.2 0 0.4 0 0.6 0 7.2-0.8 14.2-2.4 20.8l0.2-0.6c-1.6 6-4 11.4-7.2 16.2l0.2-0.2c-3.2 4.4-7 8.2-11.2 11.2h-0.2c-4.4 3-9.4 5.6-14.6 7.6l-0.4 0.2c12.4 4 23 11.6 30.4 21.4l0.2 0.2c6.8 9.8 10.8 21.8 10.8 34.8 0 0.6 0 1.2 0 1.8v0c0 0.6 0 1.2 0 1.8 0 11.2-2.4 22-6.4 31.6l0.2-0.6c-8.2 17.8-23.4 31.4-41.8 37.4l-0.4 0.2c-8.6 3.2-18.6 5.2-29.2 5.2-0.2 0-0.6 0-0.8 0v0c-0.2 0-0.2 0-0.4 0-10 0-19.6-1.6-28.8-4.4l0.6 0.2c-8.6-2.8-16-7.2-22.2-12.8v0c-6.4-5.8-11.8-12.6-15.8-20.4l-0.2-0.4c-4.4-8.2-8.4-17.6-11.2-27.4l-0.2-1 17-7.6c2.6-1.2 5.6-2 9-2 0 0 0.2 0 0.2 0v0c0.2 0 0.2 0 0.4 0 2.4 0 4.8 0.8 6.8 2v0c2.4 1.2 4.2 3 5 5.4v0c2.2 4.8 4.2 8.8 6.6 12.4l-0.4-0.6c2.2 4 5 7.4 8 10.6v0c3.2 3 6.8 5.4 10.8 7.2l0.2 0.2c4.8 2 10.4 3.2 16.2 3.2s11.4-1.2 16.4-3.4l-0.2 0.2c4.8-2.2 8.8-5.2 12.2-9v0c3.2-3.6 5.8-7.8 7.4-12.6v-0.2c1.6-4.2 2.6-9 2.6-14v0c0-0.2 0-0.4 0-0.6 0-5.6-0.6-11.2-1.8-16.4v0.6c-1.2-5-3.8-9.2-7.4-12.6v0c-4.4-3.8-9.6-6.6-15.4-8h-0.2c-7.4-1.8-15.8-3-24.4-3-1.4 0-2.8 0-4.2 0h0.2v-30.4c0.8 0 1.6 0 2.4 0 7.6 0 14.8-1 21.8-3l-0.6 0.2c5.8-1.4 11-4 15.2-7.8v0c3.6-3 6.2-7 7.6-11.4v-0.2c1.4-4.2 2.2-8.8 2.2-13.8 0-0.4 0-0.8 0-1.2v0c0.2-1.2 0.2-2.8 0.2-4.2 0-9.2-3.4-17.8-9.2-24.2v0c-5.8-5.6-13.6-9.2-22.4-9.2-0.6 0-1 0-1.6 0v0c-0.4 0-0.8 0-1.2 0-8.4 0-16 3.2-21.8 8.2v0c-6 5.4-10.6 12.2-12.8 20.2v0.2c-0.8 3.8-2.6 7-5.2 9.4v0c-2.2 1.8-5 2.8-8 2.8-0.2 0-0.4 0-0.6 0v0h-5.4l-20.4-4c1.4-11.6 4.6-22.2 9.4-31.8l-0.2 0.6c4.4-8.8 10-16.4 17-22.6v0c6.4-5.8 14.2-10.4 22.6-13.6l0.4-0.2c7.8-2.4 16.6-3.8 25.8-3.8 1-0.2 1.6-0 2.2-0v0 0z",
				"M940.4 757.8c9 0 17.6 1.8 25.4 5l-0.4-0.2c8.4 3.2 15.6 7.8 21.4 14v0c6.4 6.6 11.4 14.2 15 22.8l0.2 0.4c3.6 9.8 5.8 21 5.8 32.8s-2.2 23-6 33.4l0.2-0.6c-3.8 10.4-9.2 19.2-16.2 26.8v0c-14.2 15-34.2 24.4-56.4 24.4-0.2 0-0.4 0-0.4 0v0c-0.8 0-2 0-3 0-11.2 0-22-2.4-31.6-6.6l0.6 0.2c-9.8-4.4-18-10.2-24.8-17.6v0c-6.8-8-12.2-17.4-15.4-27.8l-0.2-0.6c-3.4-10-5.4-21.6-5.4-33.6 0-0.6 0-1.4 0-2v0c0.2-13 2.6-25.4 6.8-36.8l-0.2 0.8c5.4-14.8 12.2-27.6 20.6-39.2l-0.4 0.4 54-80c2.2-3 5-5.4 8.2-7h0.2c3.4-1.8 7.6-2.8 11.8-2.8 0.2 0 0.4 0 0.6 0v0h34.8l-72.2 96c0 1.8-2.6 3.4-3.6 5.4 4-2.4 8.8-4.4 14-5.6h0.4c4.6-1.2 10-2 15.4-2 0.2 0 0.4 0 0.8 0v0 0zM886 835.4c0 0.2 0 0.4 0 0.6 0 6.4 1 12.6 2.6 18.6l-0.2-0.4c1.6 5.6 4.2 10.4 7.8 14.6v0c3.4 4.2 7.6 7.4 12.6 9.4h0.2c4.8 2.2 10.4 3.4 16.4 3.4 0.4 0 0.6 0 1 0v0c0.2 0 0.4 0 0.6 0 6 0 11.6-1.2 16.8-3.6l-0.2 0.2c5.2-2.2 9.8-5.6 13.4-9.6v0c3.6-4 6.6-8.8 8.4-14.2v-0.2c2-5 3.2-11 3.2-17 0-0.4 0-0.8 0-1.2v0c0-0.4 0-0.8 0-1.2 0-6.4-1-12.8-3-18.6l0.2 0.4c-2-5.6-4.8-10.4-8.6-14.6v0c-3.6-3.8-8-7-12.8-9h-0.2c-4.8-1.8-10.4-2.8-16-2.8-0.4 0-0.8 0-1 0v0c-0.2 0-0.4 0-0.6 0-5.8 0-11.4 1.2-16.4 3.6l0.2-0.2c-5.2 2.4-9.4 5.4-13 9.4v0c-3.4 4.2-6.2 9-8.2 14.2l-0.2 0.4c-1.8 5.2-2.8 11.2-2.8 17.4-0.2-0.2-0.2 0.2-0.2 0.4v0 0z",
				"M1191.8 789c0 1 0 2 0 3.2 0 19-2.4 37.6-6.8 55.2l0.4-1.6c-3.6 15.2-9.8 28.4-17.8 40.2l0.2-0.4c-13 18.6-34.2 30.6-58.4 30.8v0c-1.4 0-2.8 0.2-4.4 0.2-10.8 0-21-2.4-30.2-6.6l0.4 0.2c-10.6-5.8-19.4-13.6-26-23l-0.2-0.2c-7.8-11.4-14-24.6-17.4-39l-0.2-0.8c-4-17-6.2-36.8-6.2-56.8s2.2-39.8 6.6-58.6l-0.4 1.8c3.6-15.2 9.8-28.4 17.8-40.2l-0.2 0.4c6.8-9.8 15.6-17.6 25.8-23.2l0.4-0.2c9.8-5.4 21.6-8.8 34.2-8.8v0c0.2 0 0.6 0 0.8 0 24.2 0 45.6 12.2 58.4 30.8l0.2 0.2c7.8 11.4 14 24.6 17.4 39l0.2 0.8c3.6 14.8 5.6 31.8 5.6 49.2 0 2.6 0 5.4-0.2 8l0-0.6zM1151.8 789c0-1.4 0-3 0-4.8 0-14.2-1.4-28.2-4-41.6l0.2 1.4c-1.8-10.6-5.2-20.2-10-29l0.2 0.6c-3.2-6.2-8-11.2-13.8-14.6h-0.2c-4.8-2.6-10.2-4-16.2-4s-11.6 1.4-16.4 4h0.2c-5.8 3.6-10.4 8.6-13.6 14.6l-0.2 0.2c-4.4 8.2-7.6 17.8-9.6 27.8v0.6c-2.2 12.2-3.4 26.4-3.4 40.8 0 1.4 0 3 0 4.4v-0.2c0 1.2 0 2.6 0 4 0 14.4 1.2 28.4 3.6 42.2l-0.2-1.4c2 10.6 5.4 20.2 10 29l-0.2-0.6c3.2 6.2 7.8 11.2 13.4 14.6h0.2c4.8 2.6 10.2 4 16.2 4s11.6-1.4 16.4-4h-0.2c6-3.6 10.6-8.6 13.8-14.6v-0.2c4.4-8.2 7.8-17.8 9.6-27.8v-0.6c2.4-12 3.8-26 3.8-40 0-1.6 0-3.2 0-4.8h0.4z",
				"M1228.8 682c-22.8 0-41.6-20.2-41.6-45s18.6-45 41.6-45 41.6 20.2 41.6 45-18.8 45-41.6 45zM1228.8 609.2c-13.4 0-24.4 12.6-24.4 27.8s11 27.8 24.4 27.8 24.4-12.6 24.4-27.8-11-27.8-24.4-27.8z",
				"M1304.8 329.2v44.6c196 44 325.6 120 325.6 206.6 0 91.4-145 170.6-360.4 213.6v43.2c279.4-46 472.2-143.6 472.2-256 0-109.6-177.8-204-437.4-252v0z",
				"M634.4 813l-174-173-15 128c-155.8-45.2-256-113.8-256-188 0-85.4 129.8-162.4 325.6-206.6v-44.4c-259 48.2-436.8 142.6-436.8 251.2 0 97.2 142.2 183.2 361.6 234.6l-13 104.6 207.6-106.4z",
				"M1271.8 179.4h-48.6c-0.4 0-1 0-1.4 0-5.2 0-9.8 2-13.2 5.4v0c-5.6 6.6-9.4 20.8-14.6 20.8h-16.8c-3.6-8-8.2-16.8-13.4-25.6-7.8-12.8-15-23.4-22.8-33.6l0.6 1c0 0-12-13.4-18.8-19.4-9.6-9-22-15-35.8-16.8h-0.4c-19.6-2.6-45-4.6-45-4.6l-56.8-2h-144.8l-55.4 2c0 0-25.6 2-45 4.6-14.2 1.8-26.6 7.8-36.4 16.8v0c-6.8 6-18.4 19.4-18.4 19.4-7.4 9.4-14.8 20.2-21.4 31.2l-0.8 1.4c-4.6 7.2-9 15.6-12.8 24.4l-0.6 1.2h-23.4c-5.2 0-8.8-14.2-14.6-20.8-3.4-3.4-8-5.4-13-5.4-0.4 0-0.6 0-0.8 0v0h-48.6c-0.6 0-1.4-0.2-2.2-0.2-9.4 0-17.2 7.6-17.4 17v15.4c0 9.4 20.2 23.6 38.6 24.2h64.6c-7.4 5.4-18.8 13.6-25.8 19.4-21.6 16.8-36.6 22.4-36.6 52.6 0 0.6 0 1.2 0 2 0 34.2 1.8 68 5.2 101.2l-0.4-4.2 4.2 36.2c0.6 5 1.4 9.4 2.8 13.6l-0.2-0.6v63.4c0.6 10 8.8 18 19 18 0.4 0 0.8 0 1.2 0v0h91.6c0.4 0 0.8 0 1.2 0 10.2 0 18.4-8 19-18v0-31.8h396v31.8c0.6 10 8.8 18 19 18 0.4 0 0.8 0 1.2 0v0h90.8c0.4 0 0.8 0 1.2 0 10.2 0 18.4-8 19-18v0-51.2c3.2-7.4 5.8-15.8 7-24.8v-0.6l4-36.2c3.2-29.2 5.2-62.8 5.2-97 0-0.6 0-1.4 0-2v0.2c0-30.2-15-35.8-37-52.6-7.2-5.6-18.4-14-25.8-19.4h57.8c18.4 0 38.6-14.8 38.6-24.2v-15.4c-0.2-9.4-8-16.8-17.4-16.8-0.8 0-1.2 0-1.4 0v0 0zM682.6 205.4c6.8-13.2 14.2-24.6 22.6-35.2l-0.4 0.4c5.8-7.4 12.4-13.8 19.6-19.4l0.2-0.2c13.2-5.8 28.8-9.6 45-10.6h0.4c40.2-3.6 105-3.6 105-3.6h71.6c0 0 65.2 0 105.2 3.6 16.6 0.8 32 4.6 46 10.8l-0.8-0.4c7.4 5.8 14 12.4 19.8 19.4l0.2 0.2c7.6 10 14.6 21.4 20.2 33.4l0.6 1.2c10 19.6-7.2 24.8-15.6 25l-422.8-0.2c-8.4 0.4-25.6-4.8-16.8-24.4v0zM693.2 435c-23 0-41 0-58.8 0s-19.4-16.4-19.4-23.4 5.4-8 14-8h50.4c6.8 0 13.4 1.4 19.4 3.8l-0.4-0.2c4.4 2 8 4.8 11 8.2v0c2.6 3.2 4.6 7 5.6 11.2v0.2c0.8 4.6-1.8 8-21 8l-0.8 0.2zM743.6 346.2c-15.8 2.8-34.2 4.4-52.8 4.4-4.2 0-8.4 0-12.6-0.2h0.6c-3.2 0.4-7 0.6-10.6 0.6-14 0-27.4-3.4-39-9.4l0.4 0.2c-12.2-6.4-20.4-18.4-21.4-32.6v-0.2c-1.8-16.8 0-25.4 23.8-25.6 0.8 0 1.6 0 2.4 0 27.6 0 53.8 6.2 77.2 17.2l-1-0.4c16.8 6 31.2 15 43 26.8v0c1.2 1.8 2 4.2 2 6.6 0 6.4-4.8 11.6-11 12.4v0l-1 0.2zM990.4 426.6h-157.8c-21 0-59.4-3.4-59.4-28.4 0.2-9.8 3-18.8 7.8-26.4l-0.2 0.2c8.4-18.8 26.6-31.6 48-32.4v0c23-3.2 49.6-5.2 76.6-5.2 2 0 4 0 6.2 0h-0.4c1.8 0 3.8 0 6 0 27 0 53.8 1.8 79.8 5.4l-3-0.4c20.8 0.8 38.6 12.6 48 29.8l0.2 0.4c4.6 7.4 7.6 16.4 7.6 26.2v0c0 26.6-38.4 30.8-59.4 30.8v0zM1186.4 435.8c-18 0-35.6 0-58.6 0s-22-3.4-22-8c1-4.4 3-8.2 5.8-11.4v0c3-3.4 6.6-6.2 10.6-8.2h0.2c5.8-2.4 12.4-3.6 19.4-3.6h50.4c8.2 0 14 1.4 14 8s-5.2 22.4-19.6 22.4l-0.2 0.8zM1212.8 310c-1.4 13.6-9.6 25.2-21.2 31.2l-0.2 0.2c-11.2 5.8-24.6 9.2-38.6 9.2-3.8 0-7.6-0.2-11.4-0.8h0.4c-3.6 0.2-7.6 0.2-11.8 0.2-18.8 0-37-1.6-55-4.8l1.8 0.2c-6.4-0.6-11.6-6-11.6-12.4 0-2.4 0.6-4.8 2-6.6v0c11.8-11.6 26-20.6 41.8-26.4l0.8-0.2c21.6-9.8 46.8-15.4 73.4-15.4 1.8 0 3.8 0 5.6 0h-0.2c25 0 25.6 8 23.8 24.8l0.4 0.8z"
			],
			attrs: [
			],
			width: 1820,
			isMulticolor: false,
			isMulticolor2: false,
			grid: 16,
			tags: [
				"exterior"
			],
			colorPermutations: {
			},
			defaultCode: 59652
		},
		attrs: [
		],
		properties: {
			order: 2060,
			id: 1,
			name: "360-exterior",
			prevSize: 15,
			code: 59652,
			codes: [
				59652,
				59673,
				59674,
				59675,
				59676,
				59677,
				59678
			],
			ligatures: "360-exterior"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 1
	},
	{
		icon: {
			paths: [
				"M746 686.4c0.2 0 0.6 0 1 0 9.8 0 19.2 1.8 28 5l-0.6-0.2c8.4 3.4 15.6 8 21.6 13.6v0c5.8 5.6 10.4 12.4 13.6 20l0.2 0.4c3 7 4.8 15.4 4.8 24 0 0.4 0 1 0 1.4v0c0 0.2 0 0.4 0 0.8 0 7.2-0.8 14.2-2.4 21l0.2-0.6c-1.6 6-4 11.2-7.2 15.8l0.2-0.2c-3 4.6-6.8 8.2-11.2 11.2h-0.2c-4.4 3-9.4 5.6-14.6 7.8l-0.6 0.2c12.6 3.6 23 11.2 30.4 21.2l0.2 0.2c6.2 9.6 10 21.2 10 33.8 0 1 0 1.8 0 2.8v-0.2c0 0.6 0 1.4 0 2 0 11.2-2.4 21.8-6.4 31.4l0.2-0.6c-4 9.6-9.6 17.6-16.8 24.2v0c-7 6.4-15.2 11.4-24.2 14.6l-0.6 0.2c-8.4 3-18.2 4.8-28.4 4.8-0.6 0-1 0-1.6 0v0c-0.2 0-0.2 0-0.4 0-10 0-19.6-1.6-28.8-4.4l0.6 0.2c-8.6-2.8-16-7.2-22.2-12.8v0c-6.4-5.8-11.6-12.6-15.8-20l-0.2-0.4c-4.4-8.2-8.4-17.6-11.2-27.4l-0.2-1 17-7.6c2.6-1.4 5.8-2.2 9-2.2v0c2.6 0 5 0.8 7.2 2v0c2.2 1.4 4 3.2 5 5.6v0c2 4.6 4.2 8.4 6.4 12l-0.2-0.4c2.2 4 5 7.4 8 10.6v0c3 3.2 6.8 5.6 10.8 7.4h0.2c4.2 1.8 9 2.8 14 2.8 0.4 0 0.8 0 1.2 0v0c0.4 0 0.8 0 1.2 0 5.8 0 11.4-1.2 16.4-3.6l-0.2 0.2c4.8-2.4 8.8-5.4 12.2-9.4v0c3.2-3.4 5.8-7.6 7.4-12.2v-0.2c1.6-4.2 2.6-9.2 2.6-14.2v0c0-0.2 0-0.4 0-0.8 0-5.4-0.6-10.8-1.8-16v0.4c-1.2-5-3.8-9.2-7.4-12.4v0c-4.4-3.8-9.6-6.8-15.4-8.2h-0.2c-7.8-1.8-16.6-2.8-25.8-2.8-1 0-1.8 0-2.8 0h0.2v-29.6c0.8 0 1.6 0 2.4 0 7.6 0 14.8-1 21.6-3l-0.6 0.2c6.2-1.6 11.4-4.4 15.6-8.6v0c3.6-3.2 6.2-7 8-11.4v-0.2c1.2-4.4 2-9.2 2-14.4 0-0.4 0-0.6 0-1v0c0-0.8 0.2-2 0.2-3 0-9.2-3.4-17.4-9-23.8v0c-5.8-5.6-13.6-9.2-22.4-9.2-0.6 0-1 0-1.6 0v0c-0.4 0-0.8 0-1.4 0-8.4 0-16 3-21.8 8v0c-6 5.4-10.4 12.4-12.8 20.4v0.4c-0.8 3.8-2.6 7-5.2 9.4v0c-2.4 1.8-5.2 2.8-8.4 2.8 0 0 0 0 0 0h-5.4l-20.4-4c1.4-11.8 4.6-22.4 9.4-32.2l-0.2 0.6c4.4-8.8 10.2-16.2 17-22.4v0c6.4-5.8 14.2-10.4 22.6-13.6l0.4-0.2c8.6-3 18-4.8 27.6-5v0 0z",
				"M935.2 782.8c0.2 0 0.4 0 0.4 0 8.8 0 17.2 1.6 25 4.8l-0.4-0.2c8.4 3.2 15.6 8 21.4 14.2v0c6 6.6 10.8 14.2 13.8 22.8l0.2 0.4c3.6 9.6 5.8 20.8 5.8 32.6s-2.2 22.8-6 33.2l0.2-0.6c-3.6 10.4-9.2 19.4-16.2 26.8v0c-7 7.6-15.4 13.6-24.8 17.8l-0.4 0.2c-9.2 4.2-19.8 6.6-31.2 6.6-0.6 0-1 0-1.6 0v0c-0.4 0-1 0-1.6 0-11.2 0-21.8-2.4-31.6-6.4l0.6 0.2c-9.8-4.4-18-10.4-24.6-17.8v0c-6.8-8-12.2-17.4-15.4-27.8l-0.2-0.6c-3-9.4-4.6-20.2-4.6-31.6 0-1.4 0-2.6 0-4v0.2c0.2-13 2.6-25.4 6.8-37l-0.2 0.8c5.4-14.6 12.2-27.4 20.6-38.8l-0.4 0.4 54-80c2.2-3 5-5.4 8.2-7h0.2c3.6-2 8-3.2 12.4-3.2 0 0 0 0 0 0h34.4l-67.4 90.8-4.2 5.4-3.6 5.4c4-2.2 8.8-4.2 13.8-5.6l0.4-0.2c4.4-1.2 9.4-1.8 14.4-1.8 0.6 0 1.2 0 1.8 0v0 0zM881.8 860.2c0 0.2 0 0.6 0 0.8 0 6.4 1 12.8 2.6 18.6l-0.2-0.4c1.6 5.6 4.2 10.4 7.8 14.6v0c3.4 4 7.8 7.2 12.6 9.2h0.2c4.8 2.2 10.4 3.4 16.4 3.4 0.4 0 0.6 0 1 0v0c0.2 0 0.6 0 1 0 11.6 0 22.2-5 29.4-13v0c3.6-4.2 6.6-9 8.4-14.4v-0.4c2-5 3.2-10.8 3.2-16.8 0-0.6 0-1 0-1.6v0c0-0.4 0-0.8 0-1.2 0-6.4-1-12.4-3-18.2l0.2 0.4c-2-5.6-4.8-10.4-8.6-14.6v0c-3.6-4-8-7-12.8-9h-0.2c-5-2-10.8-3.2-16.8-3.2 0 0-0.2 0-0.2 0v0c-11.4 0.2-21.4 5.2-28.4 13v0c-3.6 4-6.4 9-8.2 14.2v0.4c-2.6 5.4-4 11.6-4.4 18.2v0 0z",
				"M1186.8 813.8c0 1 0 2.4 0 3.6 0 19-2.4 37.4-7 54.8l0.4-1.6c-3.6 15.2-9.8 28.4-17.8 40.2l0.2-0.4c-6.8 9.8-15.6 17.8-26 23.2l-0.4 0.2c-9.6 4.8-20.8 7.6-32.6 7.6-0.2 0-0.2 0-0.4 0v0c-0.2 0-0.6 0-1 0-24.2 0-45.6-12.4-58-31l-0.2-0.2c-8-11.4-14-24.6-17.4-39l-0.2-0.8c-4-16.2-6.2-34.8-6.2-53.8 0-1 0-2.2 0-3.2v0.2c0-0.8 0-1.6 0-2.6 0-19.2 2.2-38 6.6-56l-0.4 1.6c3.6-15 9.8-28.2 17.8-40l-0.2 0.4c13.4-18.8 35-31 59.6-31 11.8 0 23 2.8 33 7.8l-0.4-0.2c10.8 5.6 19.8 13.4 26.2 23l0.2 0.2c7.8 11.2 14 24.4 17.4 38.8l0.2 0.8c4.2 16.2 6.6 34.6 6.6 53.8 0 1.4 0 2.6 0 3.6v0 0zM1146.6 813.8c0-1.6 0-3.4 0-5.2 0-14.4-1.4-28.4-4-42l0.2 1.4c-1.8-10.6-5.2-20.2-10-29l0.2 0.6c-3.2-6.2-8-11.2-13.8-14.8h-0.2c-4.6-2.6-10.2-4.2-16.2-4.2s-11.6 1.6-16.4 4.4h0.2c-5.8 3.6-10.4 8.6-13.6 14.6v0.2c-4.4 8.2-7.6 17.8-9.6 27.8l-0.2 0.6c-2.2 13.6-3.4 29-3.4 45s1.2 31.4 3.6 46.6l-0.2-1.6c2 10.6 5.4 20.2 10 29l-0.2-0.6c3.2 6.2 7.8 11.2 13.4 14.8h0.2c4.6 2.6 10.2 4.2 16.2 4.2s11.6-1.6 16.4-4.4h-0.2c6-3.6 10.8-8.6 13.8-14.6v-0.2c4.4-8.2 7.8-17.8 9.6-27.8v-0.6c2.4-12.2 3.8-26 3.8-40.4 0.4-1.4 0.4-2.6 0.4-3.8v0 0z",
				"M936.2 601.8h-52l-14-2c-21.2-2.2-40.6-6-59-11.6l2.2 0.6c-34.4-10.2-64.4-24.4-91.6-42.8l1.2 0.8c-20.8-14-38.8-29.6-54.6-47.2l-0.2-0.2c-14.8-16.4-27.6-35.2-37.8-55.4l-0.6-1.4c-9.6-19-16.6-41-19.8-64.4l-0.2-1c0-4-1.8-7.6-2.2-11.4v-45.8c1.4-8.6 2.8-17 4.6-25.4 4.6-22.2 12-41.8 21.8-60l-0.6 1.2c17.8-32.8 41.2-60.4 68.8-82.6l0.6-0.4c4.6-3.4 10-6.8 15.6-10l0.8-0.4c14.8-9.2 28.4-18.4 45.2-26.4 22-11.2 47.6-20 74.6-24.8l1.6-0.2c14-3 30.6-5.4 47.6-6.4h1c20 0 40.2 0 60.4 2 21 1.8 40.4 5.6 58.8 11.4l-2-0.6c34.6 10 64.8 24.2 92.2 42.8l-1.2-0.8c20.8 14 38.8 29.8 54.6 47.6l0.2 0.2c14.8 16.4 27.6 35.2 37.8 55.4l0.6 1.4c11.8 23.2 19.6 50.4 21.8 79.2v0.8c0.6 6 0.8 12.8 0.8 19.8 0 14.4-1.4 28.6-4 42.2l0.2-1.4c-4.6 23.6-12 44.6-22 63.8l0.6-1.4c-19.2 36.2-45 66.4-76.2 90l-0.6 0.4c-15.8 11.6-33.6 22.2-52.4 30.8l-1.8 0.8c-31.2 15.4-67.6 26.2-105.8 30.4l-1.4 0.2-13.6 2.2zM910.2 147.6l-34.2 2.8c-21.2 2.6-40.4 7.6-58.4 15l1.4-0.6c-28.2 10.8-52.4 26-73 45l0.2-0.2c-15 13.2-27.8 28.4-38.2 45.2l-0.4 0.8c-1 1.8-1.6 4.2-1.6 6.4 0 4.2 2 8 5 10.6v0c2.8 2.6 6.4 4.4 10.6 4.4 2.8 0 5.4-0.8 7.6-2.2v0c29.6-12.8 64.2-23.6 100-30.4l3.2-0.6c20.6-4 44.8-6.8 69.4-7.4h0.6c9.2 0 18.4 0 28.4 0 11.2 0.2 22 1 32.8 2.4l-1.4-0.2c22.8 4.2 45.8 8.2 68.2 14.2s39.8 13.6 59.8 20.8c9.2 3.2 14.8 3.2 20.2-1.4s7.4-9.4 2.6-18c-13.2-22-29.8-40.4-49.4-55.4l-0.4-0.4c-12.4-10-26.6-18.8-41.6-26.2l-1.4-0.6c-32.2-15.6-70-24.8-109.8-24.8 0 0.8-0.2 0.8-0.2 0.8v0 0zM958.8 517.4v5.4c0 7.2 6 10.2 13.6 8.2l14.6-4.8c39.2-12.6 72.6-34 99.2-62v0c17.4-18.6 31.6-40.6 41.4-64.8l0.4-1.4c2.8-7.6 0-13-10.6-12.6-11.6 0.2-22.8 1.2-33.8 3l1.4-0.2c-29.2 4.6-55 16.4-76.2 33.8l0.2-0.2c-14.2 11.4-26 25.2-34.6 40.8l-0.4 0.6c-8.6 15.2-14.4 33-16 52.2v0.4l0.8 1.6zM711.2 385.8h-7.2c-8.2 0-12.8 5.2-10 11.6 4.4 11.6 8.6 21 13.2 30l-0.8-1.6c12.6 23 29.2 42.4 49.4 57.4l0.4 0.4c8.2 6.2 16.8 12.6 25.6 18.2 18.8 11.4 40.6 20.6 63.8 26.4l1.6 0.4c8.2 2 14 0 14.2-8.6s0-8 0-12c-1.2-17.8-6.6-34.2-15-48.6l0.2 0.4c-13.4-23.6-32.8-42.6-56.2-55l-0.8-0.4c-22.6-11.8-49.4-18.8-77.8-18.8-0 0-0.4 0-0.6 0.2v0 0zM910.2 288.4c-1.2 0-2.6-0.2-4-0.2-30.4 0-55.6 23.2-58.6 52.8v0.2c4.8 30.6 30.8 53.6 62.4 53.6s57.6-23.2 62.4-53.4v-0.4c-3.2-30-28.4-53-58.8-53-1.2 0.4-2.4 0.4-3.4 0.4v0 0z",
				"M1304.8 331.4v44.6c196 44 325.6 120 325.6 206.6 0 91.4-145 170.6-360.4 213.6v43.2c279.4-45.8 472.2-143.6 472.2-256 0-109.6-177.8-204-437.4-252v0z",
				"M634.4 815.2l-174-173-15 128.2c-155.8-45.2-256-113.8-256-188 0-85.4 129.8-162.4 325.6-206.6v-44.6c-259 48.2-436.8 142.6-436.8 251.4 0 97.6 142.2 183.4 361.6 234.6l-13 104.6 207.6-106.6z",
				"M1223.6 707.2c-22.8 0-41.6-20.2-41.6-45s18.6-45 41.6-45 41.6 20.2 41.6 45-18.6 45-41.6 45zM1223.6 634.4c-13.4 0-24.4 12.6-24.4 27.8s11 27.8 24.4 27.8 24.4-12.6 24.4-27.8-10.8-27.8-24.4-27.8z"
			],
			attrs: [
			],
			width: 1820,
			isMulticolor: false,
			isMulticolor2: false,
			grid: 16,
			tags: [
				"exterior_interior_front"
			],
			colorPermutations: {
			},
			defaultCode: 59661
		},
		attrs: [
		],
		properties: {
			order: 2061,
			id: 2,
			name: "360-interior-front",
			prevSize: 15,
			code: 59661,
			codes: [
				59661,
				59679,
				59680,
				59681,
				59682,
				59684,
				59688
			],
			ligatures: "360-interior-front"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 2
	},
	{
		icon: {
			paths: [
				"M763.8 369.8v0c5.6 0.2 12 0.2 18.4 0.2 15.8 0 31.4-0.6 46.8-1.8l-2 0.2c8.4-2.8 14.8-9.8 16.8-18.4v-0.2c0-23.6-3.4-47.2-4.2-70.8 0-15.4-7.2-22.4-22.4-22.2l-105.8-0.8c-14 0-21.4 5.4-21.6 20 0 24.4-2.2 49.2-4.2 73.6-1.4 15.6 6 20 20.2 19.4 19.6 0.8 38.8 0.8 58 0.8v0z",
				"M682.6 399.6c-4.6 25.4-6.2 51.2-9.2 78.6h185.4c-3.4-28.4-5.4-53.8-10.6-79.4 0-5.4-12.2-12.6-18.8-12.6-43.2 0-85.4 0-129.2 0-7.6 1.2-14.2 6.4-17.6 13.4v0 0z",
				"M726.2 136c24.4 0 49.2 0 73.6 0s32.8-10.6 33-33.8c0-49.4-1.8-52-51.2-51.8h-52.6c-30.4 0-34.2 4.6-34.4 35.8 0 6 0 12.2 0 18.2-0.6 21.6 9.4 32.2 31.6 31.6v0z",
				"M1223.2 492.4c0-0.6 0-1.4 0-2 0-14-11.4-25.4-25.4-25.4-2.4 0-4.6 0.4-6.8 1h0.2c-18.4 8-34.2 17.6-48.6 28.8l0.4-0.4h-177l-28.4-24.4v-8.8c4.8-64.8 10.2-128.6 14-192.2 0-21 8.6-29.8 30.2-28.4 37.6 0 75.4 0 113.8 0s34.8 1.8 37.2 35c4.6 61.8 10.6 123.4 16.4 190.2 21.4-11 45.8-16 51.8-28.4 2.2-9.4 3.6-20 3.6-31s-1.2-21.6-3.8-32l0.2 1c0-12-5.2-23.8-7.2-36.2-8-46.4-16.2-93-23-139.6-0.6-28.4-23.8-51.2-52.4-51.2-1.6 0-3.2 0-4.8 0.2h0.2c-47.2 0-94.8 0-142.2 0-39 0-56.8 19.4-60.6 56.8-2 21-5.2 42-8.2 62.8-3.6-23-7.6-46-11-69.2-0.4-28.2-23.4-51-51.8-51-1.8 0-3.6 0-5.4 0.2h0.2c-47.2 0-94.8 0-142.2 0-39 0-56.8 19.6-60.6 56.8s-10.2 74.6-15 111.8-10.2 74.2-13.4 111.8c0.8 8.8 5.4 16.2 12.2 21v0c12.2 4.6 26.6 8.6 41.4 11l1.2 0.2c4.8-64.8 10.2-128.6 14-192.2 0-21 8.6-28.4 30.2-28.4 37.6 0 75.4 0 113.8 0s34.8 1.8 37.2 35c4.6 61.2 10.6 122.4 16.4 188.4v8l-20.4 23h-199.2c-1-17-15-30.4-32-30.4-3.8 0-7.6 0.6-11 2h0.2c-25.8 5.2-24.4 25.8-24.4 45.6 0 19.6 0 33.2 0 50 0 0.8-0.2 2-0.2 3 0 17.4 14.2 31.6 31.6 31.6 1 0 2 0 3.2-0.2h-0.2c97.2 0 194.8 0 292.2-2v0l277.4-1.8c2.4 0.6 5 1 7.6 1 15.4 0 28-12.2 28.4-27.4v0c0.6-11 1-23.8 1-36.6s-0.4-25.8-1.2-38.4l0.2 1.4z",
				"M1041.4 367.8v0c9.4 0.6 20.4 0.8 31.6 0.8s22.2-0.4 33-1h-1.6c8.4-3 14.6-10 16.8-18.6v-0.2c0-23.4-3.4-47-4.2-70.6 0-15.4-7.2-22.4-22.4-22.4-35.2 0-70.6 0-105.2 0-14 0-21.4 5.4-21.6 20.2 0 24.4-1.4 49-4.2 73.4 0 15.6 6 20.2 20.2 19.6 19.2-1.4 38.4-1 57.6-1.2v0z",
				"M959.8 398.2c-4.6 25.6-6.2 51.4-9.2 78.6h185.4c-3.4-28.4-5.4-53.8-10.6-79 0-5.4-12.2-12.6-18.8-12.8-43.2 0-85.4 0-129.2 0-7.6 1.4-14.2 6.2-17.6 13.2v0 0z",
				"M1003.8 134.2c24.4 0 49.2 0 73.6 0s31.8-11 31.8-34.4c0-49.8-1.8-52-51.2-52h-51.4c-30.4 0-34.2 4.6-34.4 35.8 0 6 0 12.2 0 18.2-0.6 22.6 9.4 33 31.6 32.4v0z",
				"M445.2 805.2c-155.8-45.2-256-113.8-256-188 0-85.4 129.8-162.4 325.6-206.6v-44.6c-258.8 48.4-436.6 142.6-436.6 251.2 0 97.6 142.2 183.4 361.6 234.6l-13 105 206.6-106.8-173.2-173-15 128.2z",
				"M778.6 841.4c5.8-2.2 10.8-4.8 15.4-7.8l-0.2 0.2c4.4-3.2 8.2-7 11.2-11.6v-0.2c3.2-4.4 5.6-9.6 7-15.2v-0.4c1.4-6 2.2-13.2 2.2-20.4 0-0.2 0-0.6 0-0.8v0c0-0.4 0-0.8 0-1.2 0-8.8-1.8-17-5-24.6l0.2 0.4c-3.2-8-7.6-14.8-13-20.4v0c-6-5.8-13.2-10.4-21.2-13.4l-0.4-0.2c-8.2-3-17.6-4.8-27.4-4.8-0.4 0-0.8 0-1 0v0c-0.2 0-0.6 0-1 0-9.8 0-19.4 1.6-28.2 4.8l0.6-0.2c-9 3.2-16.6 7.8-23.2 13.8v0c-7 6.4-12.8 13.8-16.8 22.4l-0.2 0.4c-4.4 9-7.8 19.6-9 30.8v0.4l20.4 4h5.4c0 0 0 0 0 0 3.2 0 6.2-1 8.4-2.8v0c2.6-2.4 4.4-5.6 5-9.2v-0.2c2.4-8.2 6.8-15.2 12.8-20.8v0c6-5 13.8-8 22.2-8 0.2 0 0.6 0 0.8 0v0c0.4 0 1 0 1.6 0 8.8 0 16.6 3.4 22.4 9.2v0c5.6 6.4 9 14.8 9 24 0 1 0 2-0.2 2.8v-0.2c0 0.4 0 0.8 0 1.2 0 5-0.8 10-2 14.6v-0.4c-1.8 4.6-4.4 8.6-8 11.6v0c-4.2 3.6-9.2 6.4-14.8 7.6h-0.2c-6.4 1.8-13.6 2.8-21.2 2.8-0.8 0-1.8 0-2.6 0h0.2v30.4c1 0 2 0 3.2 0 9 0 17.8 1.2 26 3.4l-0.8-0.2c6 1.4 11.4 4.2 15.6 8v0c3.6 3.2 6.2 7.6 7.4 12.4v0.2c1 4.6 1.8 10 1.8 15.6 0 0.4 0 0.6 0 1v0c0 5-1 9.8-2.6 14.2v-0.2c-3.4 9.8-10.4 17.6-19.4 21.8h-0.2c-4.8 2.2-10.4 3.4-16.2 3.4-0.4 0-0.8 0-1.2 0v0c-0.4 0-0.8 0-1 0-5 0-9.8-1-14.2-3h0.2c-4.4-1.8-8-4.2-11-7.4v0c-3-3-5.6-6.4-7.8-10l-0.2-0.2c-2-3.2-4-7.2-6-11.2l-0.4-0.8c-1-2.4-2.8-4.4-5-5.6v0c-2-1-4.4-1.8-6.8-1.8 0 0-0.2 0-0.2 0v0c0 0-0.2 0-0.2 0-3.2 0-6.4 0.8-9 2h0.2l-17 7.6c3 10.8 7 20.4 11.8 29.2l-0.4-0.8c4.2 8 9.6 14.8 15.8 20.8v0c6.2 5.4 13.6 9.6 21.8 12.4l0.4 0.2c9 3 19.2 4.8 29.8 4.8s21-1.8 30.6-5l-0.6 0.2c9.6-3.4 17.8-8.4 24.8-14.8v0c7-6.6 12.8-14.6 16.6-23.4l0.2-0.4c4-9.2 6.2-20 6.2-31.4 0-0.6 0-1.2 0-1.8v0c0-0.8 0-1.8 0-2.8 0-12.4-3.8-24-10.2-33.8l0.2 0.2c-7.8-10.4-18.6-18-31.2-21.6l-0.2 0.2z",
				"M981.6 836.2c-5.8-6.2-13-11-21-14l-0.4-0.2c-7.4-2.8-16-4.6-25-4.6-5.8 0-11.6 0.8-17.2 2l0.4-0.2c-5.4 1.6-10.2 3.4-14.6 5.8l0.4-0.2 3.6-5.2 4.2-5.6 68-90h-34.8c-0.2 0-0.4 0-0.6 0-4.4 0-8.4 1-12 3h0.2c-3.2 1.8-6 4.2-8.2 7v0l-54 80c-8 11.4-14.8 24.4-19.8 38.4l-0.4 1.2c-4 10.8-6.4 23.2-6.6 36v0c0 0.6 0 1.2 0 2 0 12.2 2 23.8 5.6 34.8l-0.2-0.8c3.4 11 8.8 20.4 15.8 28.6v-0.2c6.8 7.6 15 13.6 24.2 17.8l0.4 0.2c9.4 4.2 20.2 6.6 31.6 6.6 0.4 0 0.8 0 1 0v0c0.2 0 0.4 0 0.6 0 11.6 0 22.6-2.4 32.6-6.8l-0.6 0.2c10-4.6 18.4-10.6 25.2-18.2v0c7-7.4 12.6-16.2 16-26l0.2-0.6c3.6-9.8 5.8-21 5.8-32.8s-2.2-23-6-33.4l0.2 0.6c-3-9.8-8-18.4-14.6-25.4v0 0zM960.2 913.6c-2 5.6-5 10.4-8.6 14.6v0c-3.4 4.4-7.8 8-12.8 10.4h-0.2c-4.8 2.2-10.6 3.4-16.4 3.4-0.2 0-0.4 0-0.6 0v0c-0.2 0-0.6 0-1 0-6 0-11.6-1.2-16.6-3.6l0.2 0.2c-5-2.2-9.4-5.4-12.8-9.4v0c-3.4-4-6-9-7.6-14.2v-0.2c-1.6-5.4-2.6-11.8-2.6-18.2 0-0.4 0-0.6 0-1v0c0-0.2 0-0.4 0-0.6 0-6.2 1-12.2 3-17.6l-0.2 0.4c3.4-10.8 11.2-19.4 21-24l0.2-0.2c4.8-2.2 10.4-3.4 16.2-3.4 0.2 0 0.4 0 0.6 0v0c6 0 11.6 1.2 16.8 3.2l-0.4-0.2c5.2 2.2 9.4 5.2 13 9v0c3.6 4 6.6 8.8 8.4 14.2v0.2c1.8 5.4 2.8 11.6 2.8 18.2 0 0.4 0 0.8 0 1.2v0c0 0.4 0 0.6 0 1 0 5.8-1 11.4-3 16.6h0.6z",
				"M1162.6 752c-6.8-9.8-15.6-17.8-26-23.2l-0.4-0.2c-9.6-4.8-20.8-7.6-32.6-7.6-0.2 0-0.2 0-0.4 0v0c-0.4 0-0.8 0-1.2 0-24 0-45.2 12.2-57.8 30.8l-0.2 0.2c-7.8 11.4-14 24.6-17.4 39l-0.2 0.8c-4 16.2-6.2 34.8-6.2 53.8 0 1 0 2.2 0 3.2v-0.2c0 0.8 0 1.6 0 2.6 0 19.2 2.2 38 6.6 56l-0.4-1.6c3.6 15 9.6 28.2 17.8 40l-0.2-0.4c6.8 9.8 15.6 17.8 25.8 23.4l0.4 0.2c9.4 4.8 20.6 7.6 32.4 7.6 0.2 0 0.4 0 0.6 0v0c0.2 0 0.2 0 0.4 0 11.8 0 23.2-2.8 33-7.8l-0.4 0.2c10.8-5.6 19.8-13.6 26.2-23.4l0.2-0.2c8-11.2 14-24.4 17.4-38.8l0.2-0.8c4.2-16.2 6.6-34.6 6.6-53.8 0-1 0-2.2 0-3.2v0.2c0-1 0-2.4 0-3.6 0-19-2.4-37.4-7-54.8l0.4 1.6c-3.6-15.2-9.8-28.4-17.8-40.2l0.2 0.2zM1142.8 894.2c-1.8 10.6-5.2 20.2-10 29l0.2-0.4c-3.2 6.2-8 11.2-13.8 14.8h-0.2c-4.6 2.6-10.2 4.2-16.2 4.2s-11.6-1.6-16.4-4.4h0.2c-5.8-3.6-10.4-8.6-13.6-14.6v-0.2c-4.4-8.2-7.8-17.8-9.6-27.8v-0.6c-2.2-12.4-3.4-26.4-3.4-41 0-1.4 0-2.8 0-4.2v0.2c0-1.2 0-2.6 0-4 0-14.4 1.2-28.4 3.6-42.2l-0.2 1.4c2-10.6 5.4-20.2 10-29l-0.2 0.6c3.2-6.2 7.8-11.2 13.4-14.8h0.2c4.6-2.6 10.2-4.2 16.2-4.2s11.6 1.6 16.4 4.4h-0.2c6 3.6 10.8 8.6 13.8 14.6v0.2c4.4 8.2 7.8 17.8 9.6 27.8v0.6c2.4 12 3.8 26 3.8 40 0 1.6 0 3.2 0 4.8v-0.2c0 1.2 0 2.4 0 3.8 0 14.2-1.4 28.2-4 41.6l0.2-1.4 0.2 1z",
				"M1304.8 366v44.6c196 44.4 325.6 120 325.6 206.6 0 91.4-145 170.6-360.4 213.6v43.2c279.4-45.8 472.2-143.6 472.2-256 0-109.4-177.8-203.6-437.4-252v0z",
				"M1223.6 770c-22.8 0-41.6-20.2-41.6-45s18.6-45 41.6-45 41.6 20.2 41.6 45c0 24.8-18.6 45-41.6 45zM1223.6 697.2c-13.4 0-24.4 12.6-24.4 27.8 0 15.4 11 27.8 24.4 27.8s24.4-12.6 24.4-27.8c0.2-15.4-10.8-27.8-24.4-27.8z"
			],
			attrs: [
			],
			width: 1820,
			isMulticolor: false,
			isMulticolor2: false,
			grid: 16,
			tags: [
				"interior_rear"
			],
			colorPermutations: {
			},
			defaultCode: 59654
		},
		attrs: [
		],
		properties: {
			order: 2062,
			id: 3,
			name: "360-interior-rear",
			prevSize: 15,
			code: 59654,
			codes: [
				59654,
				59656,
				59662,
				59663,
				59664,
				59665,
				59666,
				59667,
				59668,
				59669,
				59670,
				59671,
				59672
			],
			ligatures: "360-interior-rear"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 3
	},
	{
		icon: {
			paths: [
				"M512 128c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 936c-198.824 0-360-161.178-360-360 0-198.824 161.176-360 360-360 198.822 0 360 161.176 360 360 0 198.822-161.178 360-360 360zM934.784 287.174c16.042-28.052 25.216-60.542 25.216-95.174 0-106.040-85.96-192-192-192-61.818 0-116.802 29.222-151.92 74.596 131.884 27.236 245.206 105.198 318.704 212.578v0zM407.92 74.596c-35.116-45.374-90.102-74.596-151.92-74.596-106.040 0-192 85.96-192 192 0 34.632 9.174 67.122 25.216 95.174 73.5-107.38 186.822-185.342 318.704-212.578z",
				"M704 512h-128v-128h-128v128h-128v128h128v128h128v-128h128z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"alarm-add",
				"alarm",
				"alarm-plus",
				"clock"
			],
			defaultCode: 59988,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			order: 2063,
			id: 4,
			prevSize: 15,
			code: 59988,
			ligatures: "alarm-add",
			name: "alarm-add"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 4
	},
	{
		icon: {
			paths: [
				"M512 128c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 936c-198.824 0-360-161.178-360-360 0-198.824 161.176-360 360-360 198.822 0 360 161.176 360 360 0 198.822-161.178 360-360 360zM934.784 287.174c16.042-28.052 25.216-60.542 25.216-95.174 0-106.040-85.96-192-192-192-61.818 0-116.802 29.222-151.92 74.596 131.884 27.236 245.206 105.198 318.704 212.578v0zM407.92 74.596c-35.116-45.374-90.102-74.596-151.92-74.596-106.040 0-192 85.96-192 192 0 34.632 9.174 67.122 25.216 95.174 73.5-107.38 186.822-185.342 318.704-212.578z",
				"M512 576v-256h-64v320h256v-64z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"alarm",
				"time",
				"clock"
			],
			defaultCode: 59987,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 5,
			order: 2064,
			prevSize: 15,
			code: 59987,
			ligatures: "alarm-clock",
			name: "alarm-clock"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 5
	},
	{
		icon: {
			paths: [
				"M512 128c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 936c-198.824 0-360-161.178-360-360 0-198.824 161.176-360 360-360 198.822 0 360 161.176 360 360 0 198.822-161.178 360-360 360zM934.784 287.174c16.042-28.052 25.216-60.542 25.216-95.174 0-106.040-85.96-192-192-192-61.818 0-116.802 29.222-151.92 74.596 131.884 27.236 245.206 105.198 318.704 212.578v0zM407.92 74.596c-35.116-45.374-90.102-74.596-151.92-74.596-106.040 0-192 85.96-192 192 0 34.632 9.174 67.122 25.216 95.174 73.5-107.38 186.822-185.342 318.704-212.578z",
				"M704 416l-256 256-96-96-64 64 160 160 320-320z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"alarm-check",
				"alarm",
				"alarm-tick",
				"clock"
			],
			defaultCode: 59989,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			order: 2065,
			id: 6,
			prevSize: 15,
			code: 59989,
			ligatures: "alarm-set",
			name: "alarm-set"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 6
	},
	{
		icon: {
			paths: [
				"M877.254 621.254l-320 320c-24.992 24.994-65.514 24.994-90.508 0l-320-320c-24.994-24.994-24.994-65.516 0-90.51 24.994-24.996 65.516-24.996 90.51 0l210.744 210.746v-613.49c0-35.346 28.654-64 64-64s64 28.654 64 64v613.49l210.746-210.746c12.496-12.496 28.876-18.744 45.254-18.744s32.758 6.248 45.254 18.746c24.994 24.994 24.994 65.514 0 90.508z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"arrow-down"
			],
			defaultCode: 61027,
			grid: 16
		},
		attrs: [
		],
		properties: {
			order: 2191,
			id: 145,
			prevSize: 15,
			ligatures: "arrow-down8, down8",
			name: "arrow-down",
			code: 61027
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 7
	},
	{
		icon: {
			paths: [
				"M402.746 877.254l-320-320c-24.994-24.992-24.994-65.516 0-90.51l320-320c24.994-24.992 65.516-24.992 90.51 0 24.994 24.994 24.994 65.516 0 90.51l-210.746 210.746h613.49c35.346 0 64 28.654 64 64s-28.654 64-64 64h-613.49l210.746 210.746c12.496 12.496 18.744 28.876 18.744 45.254s-6.248 32.758-18.744 45.254c-24.994 24.994-65.516 24.994-90.51 0z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"arrow-left"
			],
			defaultCode: 61029,
			grid: 16
		},
		attrs: [
		],
		properties: {
			order: 2192,
			id: 146,
			prevSize: 15,
			ligatures: "arrow-left8, left11",
			name: "arrow-left",
			code: 61029
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 8
	},
	{
		icon: {
			paths: [
				"M621.254 877.254l320-320c24.994-24.992 24.994-65.516 0-90.51l-320-320c-24.994-24.992-65.516-24.992-90.51 0-24.994 24.994-24.994 65.516 0 90.51l210.746 210.746h-613.49c-35.346 0-64 28.654-64 64s28.654 64 64 64h613.49l-210.746 210.746c-12.496 12.496-18.744 28.876-18.744 45.254s6.248 32.758 18.744 45.254c24.994 24.994 65.516 24.994 90.51 0z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"arrow-right"
			],
			defaultCode: 61025,
			grid: 16
		},
		attrs: [
		],
		properties: {
			order: 2190,
			id: 144,
			prevSize: 15,
			ligatures: "arrow-right8, right10",
			name: "arrow-right",
			code: 61025
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 9
	},
	{
		icon: {
			paths: [
				"M877.254 402.746l-320-320c-24.992-24.994-65.514-24.994-90.508 0l-320 320c-24.994 24.994-24.994 65.516 0 90.51 24.994 24.996 65.516 24.996 90.51 0l210.744-210.746v613.49c0 35.346 28.654 64 64 64s64-28.654 64-64v-613.49l210.746 210.746c12.496 12.496 28.876 18.744 45.254 18.744s32.758-6.248 45.254-18.746c24.994-24.994 24.994-65.514 0-90.508z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"arrow-up"
			],
			defaultCode: 61023,
			grid: 16
		},
		attrs: [
		],
		properties: {
			order: 2189,
			id: 143,
			prevSize: 15,
			ligatures: "arrow-up8, up8",
			name: "arrow-up",
			code: 61023
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 10
	},
	{
		icon: {
			paths: [
				"M704 608v-224h-704v-128h704v-224l288 288-288 288zM320 640h704v128h-704v224l-288-288 288-288v224z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"transmission",
				"arrows"
			],
			defaultCode: 60999,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 11,
			order: 2066,
			prevSize: 15,
			code: 60999,
			ligatures: "arrows-left-right",
			name: "arrows-left-right"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 11
	},
	{
		icon: {
			paths: [
				"M665.832 327.048l-64.952-64.922-324.81 324.742c-53.814 53.792-53.814 141.048 0 194.844 53.804 53.792 141.060 53.792 194.874 0l389.772-389.708c89.714-89.662 89.714-235.062 0-324.726-89.666-89.704-235.112-89.704-324.782 0l-409.23 409.178c-0.29 0.304-0.612 0.576-0.876 0.846-125.102 125.096-125.102 327.856 0 452.906 125.054 125.056 327.868 125.056 452.988 0 0.274-0.274 0.516-0.568 0.82-0.876l0.032 0.034 279.332-279.292-64.986-64.92-279.33 279.262c-0.296 0.268-0.564 0.57-0.846 0.844-89.074 89.058-233.98 89.058-323.076 0-89.062-89.042-89.062-233.922 0-322.978 0.304-0.304 0.604-0.582 0.888-0.846l-0.046-0.060 409.28-409.166c53.712-53.738 141.144-53.738 194.886 0 53.712 53.734 53.712 141.148 0 194.84l-389.772 389.7c-17.936 17.922-47.054 17.922-64.972 0-17.894-17.886-17.894-47.032 0-64.92l324.806-324.782z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"attachment",
				"paperclip"
			],
			defaultCode: 60585,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 12,
			order: 2067,
			prevSize: 15,
			code: 60585,
			ligatures: "attach",
			name: "attach"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 12
	},
	{
		icon: {
			paths: [
				"M832 192l-192-192-512 512 512 512 192-192-320-320zM0 0v1024h128v-512-512z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"first",
				"player"
			],
			defaultCode: 60850,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 13,
			order: 2068,
			prevSize: 15,
			code: 60850,
			ligatures: "back-to-start",
			name: "back-to-start"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 13
	},
	{
		icon: {
			paths: [
				"M0 192h128v640h-128zM192 192h64v640h-64zM320 192h64v640h-64zM512 192h64v640h-64zM768 192h64v640h-64zM960 192h64v640h-64zM640 192h32v640h-32zM448 192h32v640h-32zM864 192h32v640h-32z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"barcode"
			],
			defaultCode: 59894,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 14,
			order: 2069,
			ligatures: "barcode",
			prevSize: 15,
			code: 59894,
			name: "barcode"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 14
	},
	{
		icon: {
			paths: [
				"M899.714 860.807c-87.115-192.069-65.666-419.193-65.666-422.178 0-155.974-98.915-287.445-233.996-328.191 1.437-6.042 2.271-12.984 2.291-20.117v-0.013c0-49.837-40.401-90.239-90.239-90.239s-90.239 40.401-90.239 90.239v0c0.032 7.003 0.84 13.801 2.341 20.334l-0.12-0.62c-135.983 40.469-235.592 172.286-235.592 328.746 0.012 14.493 0.869 28.772 2.525 42.807l-0.165-1.714c2.846 68.928 0.208 233.787-66.568 380.946h224.555c0 90.091 73.033 163.124 163.124 163.124s163.124-73.033 163.124-163.124v0h224.625zM584.851 860.807c0 40.253-32.632 72.885-72.885 72.885s-72.885-32.632-72.885-72.885v0h145.77z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"bell"
			],
			defaultCode: 59992,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 15,
			order: 2070,
			ligatures: "bell",
			prevSize: 15,
			code: 59992,
			name: "bell"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 15
	},
	{
		icon: {
			paths: [
				"M834.048 438.698c0-155.974-98.915-287.445-233.996-328.191 1.437-6.042 2.271-12.984 2.291-20.117v-0.013c0-49.837-40.401-90.239-90.239-90.239s-90.239 40.401-90.239 90.239v0c0.032 7.003 0.84 13.801 2.341 20.334l-0.12-0.62c-135.983 40.33-235.592 172.148-235.592 328.607 0.012 14.493 0.869 28.772 2.525 42.807l-0.165-1.714c2.846 68.928 0.208 233.787-66.568 380.946h224.555c0 90.091 73.033 163.124 163.124 163.124s163.124-73.033 163.124-163.124v0h224.625c-87.115-191.931-65.666-419.054-65.666-422.039zM511.272 194.36c123.419 0 223.861 108.009 225.597 241.215-1.447 21.267-2.271 46.096-2.271 71.117 0 91.183 10.95 179.808 31.607 264.632l-1.57-7.628h-504.85c18.4-74.14 28.956-159.254 28.956-246.834 0-14.282-0.281-28.499-0.837-42.645l0.064 2.034c0-2.499 0-4.928-0.555-7.427-1.103-9.040-1.733-19.508-1.735-30.123v-0.002c0-134.664 101.206-244.338 225.597-244.338zM511.966 933.623c-40.237-0.040-72.846-32.648-72.885-72.881v-0.004h145.77c0 0.021 0 0.045 0 0.069 0 40.267-32.623 72.915-72.881 72.954h-0.004z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"bell-o"
			],
			defaultCode: 59687,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 16,
			order: 2071,
			ligatures: "bell-o",
			prevSize: 15,
			code: 59687,
			name: "bell-o"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 16
	},
	{
		icon: {
			paths: [
				"M874.040 149.96c-96.706-96.702-225.28-149.96-362.040-149.96s-265.334 53.258-362.040 149.96c-96.702 96.706-149.96 225.28-149.96 362.040s53.258 265.334 149.96 362.040c96.706 96.702 225.28 149.96 362.040 149.96s265.334-53.258 362.040-149.96c96.702-96.706 149.96-225.28 149.96-362.040s-53.258-265.334-149.96-362.040zM896 512c0 82.814-26.354 159.588-71.112 222.38l-535.266-535.268c62.792-44.758 139.564-71.112 222.378-71.112 211.738 0 384 172.262 384 384zM128 512c0-82.814 26.354-159.586 71.112-222.378l535.27 535.268c-62.794 44.756-139.568 71.11-222.382 71.11-211.738 0-384-172.262-384-384z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"blocked"
			],
			defaultCode: 60775,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 17,
			order: 2072,
			ligatures: "blocked",
			prevSize: 15,
			code: 60775,
			name: "blocked"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 17
	},
	{
		icon: {
			paths: [
				"M330.567 991.999l-10.822-5.092c52.202-131.14 103.766-262.282 158.514-401.061h-275.013l487.64-553.846 10.822 8.276-157.878 397.878h276.923l-490.186 553.846z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			grid: 16,
			tags: [
				"bolt"
			],
			defaultCode: 59649,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			order: 2073,
			id: 18,
			name: "bolt",
			prevSize: 15,
			code: 59649,
			ligatures: "bolt"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 18
	},
	{
		icon: {
			paths: [
				"M512 64c282.77 0 512 186.25 512 416 0 229.752-229.23 416-512 416-27.156 0-53.81-1.734-79.824-5.044-109.978 109.978-241.25 129.7-368.176 132.596v-26.916c68.536-33.578 128-94.74 128-164.636 0-9.754-0.758-19.33-2.164-28.696-115.796-76.264-189.836-192.754-189.836-323.304 0-229.75 229.23-416 512-416z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"bubble",
				"comment",
				"chat",
				"talk"
			],
			defaultCode: 60097,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 19,
			order: 2074,
			prevSize: 15,
			code: 60097,
			ligatures: "bubble",
			name: "bubble"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 19
	},
	{
		icon: {
			width: 1152,
			paths: [
				"M480 0v0c265.096 0 480 173.914 480 388.448s-214.904 388.448-480 388.448c-25.458 0-50.446-1.62-74.834-4.71-103.106 102.694-222.172 121.108-341.166 123.814v-25.134c64.252-31.354 116-88.466 116-153.734 0-9.106-0.712-18.048-2.030-26.794-108.558-71.214-177.97-179.988-177.97-301.89 0-214.534 214.904-388.448 480-388.448zM996 870.686c0 55.942 36.314 104.898 92 131.772v21.542c-103.126-2.318-197.786-18.102-287.142-106.126-21.14 2.65-42.794 4.040-64.858 4.040-95.47 0-183.408-25.758-253.614-69.040 144.674-0.506 281.26-46.854 384.834-130.672 52.208-42.252 93.394-91.826 122.414-147.348 30.766-58.866 46.366-121.582 46.366-186.406 0-10.448-0.45-20.836-1.258-31.168 72.57 59.934 117.258 141.622 117.258 231.676 0 104.488-60.158 197.722-154.24 258.764-1.142 7.496-1.76 15.16-1.76 22.966z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"bubbles"
			],
			defaultCode: 60099,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 20,
			order: 2075,
			ligatures: "bubbles",
			prevSize: 15,
			code: 60099,
			name: "bubbles"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 20
	},
	{
		icon: {
			paths: [
				"M320 512c0-106.039 85.961-192 192-192 106.039 0 192 85.961 192 192 0 106.039-85.961 192-192 192-106.039 0-192-85.961-192-192z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"circle-small"
			],
			defaultCode: 60520,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 21,
			order: 2076,
			prevSize: 15,
			code: 60520,
			ligatures: "bullet",
			name: "bullet"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 21
	},
	{
		icon: {
			paths: [
				"M0 960c0 35.348 28.654 64 64 64h896c35.348 0 64-28.652 64-64v-576h-1024v576zM704 448h256v128h-256v-128zM704 640h256v128h-256v-128zM704 832h256v128h-256v-128zM384 448h256v128h-256v-128zM384 640h256v128h-256v-128zM384 832h256v128h-256v-128zM64 448h256v128h-256v-128zM64 640h256v128h-256v-128zM64 832h256v128h-256v-128zM960 128h-128v-91.428c0-20.198-14.326-36.572-32-36.572-17.672 0-32 16.374-32 36.572v91.428h-512v-91.428c0-20.198-14.326-36.572-32-36.572s-32 16.374-32 36.572v91.428h-128c-35.346 0-64 28.654-64 64v128h1024v-128c0-35.346-28.654-64-64-64zM224 288c-35.346 0-64-28.654-64-64 0-23.684 12.876-44.348 32-55.416v55.416c0 17.672 14.328 32 32 32s32-14.328 32-32v-55.416c19.124 11.068 32 31.732 32 55.416 0 35.346-28.654 64-64 64zM800 288c-35.344 0-64-28.654-64-64 0-23.684 12.876-44.348 32-55.416v55.416c0 17.672 14.328 32 32 32 17.674 0 32-14.328 32-32v-55.416c19.126 11.068 32 31.732 32 55.416 0 35.346-28.652 64-64 64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"calendar"
			],
			defaultCode: 59999,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 22,
			order: 2077,
			ligatures: "calendar",
			prevSize: 15,
			code: 59999,
			name: "calendar"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 22
	},
	{
		icon: {
			paths: [
				"M304 608c0 114.876 93.124 208 208 208s208-93.124 208-208-93.124-208-208-208-208 93.124-208 208zM960 256h-224c-16-64-32-128-96-128h-256c-64 0-80 64-96 128h-224c-35.2 0-64 28.8-64 64v576c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-576c0-35.2-28.8-64-64-64zM512 892c-156.85 0-284-127.148-284-284 0-156.85 127.15-284 284-284 156.852 0 284 127.15 284 284 0 156.852-127.146 284-284 284zM960 448h-128v-64h128v64z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"camera",
				"photo",
				"picture",
				"image"
			],
			defaultCode: 59716,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 23,
			order: 2078,
			prevSize: 15,
			code: 59716,
			ligatures: "camera",
			name: "camera"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 23
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM768 672l-96 96-160-160-160 160-96-96 160-160-160-160 96-96 160 160 160-160 96 96-160 160 160 160z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cancel-circle"
			],
			defaultCode: 60771,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 24,
			order: 2079,
			ligatures: "cancel-circle",
			prevSize: 15,
			code: 60771,
			name: "cancel-circle"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 24
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416zM672 256l-160 160-160-160-96 96 160 160-160 160 96 96 160-160 160 160 96-96-160-160 160-160z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cancel-circle-o"
			],
			defaultCode: 60770,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 25,
			order: 2080,
			ligatures: "cancel-circle-o",
			prevSize: 15,
			code: 60770,
			name: "cancel-circle-o"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 25
	},
	{
		icon: {
			paths: [
				"M1191.040 258.56h-72.96c-0.308-0.013-0.669-0.021-1.032-0.021-8.261 0-15.62 3.865-20.367 9.885l-0.042 0.055c-8.32 11.52-13.76 37.12-21.12 37.12h-24.96c-7.167-18.8-13.949-33.878-21.447-48.529l1.287 2.769c-11.306-23.498-21.961-42.68-33.549-61.218l1.549 2.658s-17.6-24-27.52-34.56c-13.464-15.603-32.122-26.399-53.263-29.696l-0.497-0.064c-28.8-4.8-66.56-8.32-66.56-8.32l-82.56-4.16h-215.040l-82.24 3.52s-37.76 3.52-66.56 8.32c-21.064 3.822-39.112 14.656-52.053 29.95l-0.107 0.13c-9.92 10.56-27.52 34.56-27.52 34.56-10.039 15.879-20.694 35.061-30.35 54.82l-1.65 3.74c-6.21 11.881-12.993 26.959-19.014 42.418l-1.146 3.342h-32c-7.36 0-12.8-25.6-21.12-37.12-4.788-6.076-12.147-9.941-20.408-9.941-0.363 0-0.724 0.007-1.083 0.022l0.051-0.002h-76.8c-0.199-0.005-0.434-0.008-0.669-0.008-15.729 0-28.48 12.751-28.48 28.48 0 0.453 0.011 0.903 0.031 1.351l-0.002-0.063v27.2c0 17.28 29.76 42.56 57.28 43.2h96l-38.4 35.84c-32 30.080-54.72 40.32-54.72 96 0 100.8 7.36 177.28 7.36 177.28l6.080 64c0.933 9.082 2.286 17.147 4.103 25.035l-0.263-1.355v113.6c-0 0.017-0 0.037-0 0.058 0 16.998 13.253 30.9 29.989 31.938l0.091 0.005h135.68c16.683-1.206 29.76-15.037 29.76-31.922 0-0.028-0-0.055-0-0.083l0 0.004v-57.92h584.32v57.28c-0 0.023-0 0.051-0 0.078 0 16.885 13.077 30.715 29.656 31.915l0.104 0.006h136c16.683-1.206 29.76-15.037 29.76-31.922 0-0.028-0-0.055-0-0.083l0 0.004v-91.52c4.828-13.244 8.538-28.722 10.461-44.749l0.099-1.011 6.080-64s7.36-76.48 7.36-177.28c0-54.4-22.4-64-54.72-96l-38.080-34.88h87.040c27.52 0 57.28-25.92 57.28-43.2v-27.52c0.010-0.288 0.016-0.627 0.016-0.968 0-15.729-12.751-28.48-28.48-28.48-0.231 0-0.461 0.003-0.691 0.008l0.034-0.001zM320 304.96c9.832-23.959 20.558-44.374 32.932-63.629l-0.932 1.549c8.807-13.128 18.506-24.555 29.343-34.789l0.097-0.091c19.219-10.779 41.932-17.716 66.122-19.179l0.438-0.021c59.2-6.4 155.2-6.4 155.2-6.4h106.24s96 0 155.52 6.4c24.738 1.374 47.579 8.324 67.662 19.604l-0.782-0.404c11.044 10.255 20.755 21.694 29.007 34.182l0.433 0.698c11.442 17.706 22.168 38.121 31.049 59.496l0.951 2.584c14.4 35.2-10.56 44.48-23.36 45.12s-201.92 1.92-201.92 1.92l-111.68-1.6-112.32 1.6s-188.48 0-201.28 0-36.48-11.84-22.72-47.040zM336 716.8h-87.040c-21.12 0-28.8-29.76-28.8-41.92s8.32-14.080 20.8-14.4h74.24c10.349 0.056 20.136 2.41 28.893 6.577l-0.413-0.177c6.53 3.895 11.972 8.928 16.211 14.878l0.109 0.162c3.978 5.83 6.887 12.72 8.269 20.148l0.051 0.332c0 8-3.52 14.4-32.32 14.4zM410.88 556.8c-23.884 4.891-51.334 7.691-79.439 7.691-5.824 0-11.621-0.12-17.387-0.358l0.825 0.027c-4.578 0.673-9.863 1.057-15.238 1.057-21.224 0-41.050-5.989-57.878-16.37l0.476 0.273c-18.941-12.967-31.37-34.248-31.998-58.465l-0.002-0.095c-2.24-30.080 0-45.76 35.52-46.080 1.117-0.020 2.435-0.031 3.756-0.031 41.454 0 80.325 11.055 113.827 30.378l-1.103-0.587c25.492 11.356 46.902 27.741 63.771 48.036l0.229 0.284c2.074 3.448 3.3 7.61 3.3 12.058 0 11.3-7.914 20.751-18.502 23.112l-0.158 0.030zM774.72 699.2h-233.6c-32 0-88-5.76-88-52.8 0.086-17.159 4.214-33.333 11.479-47.647l-0.279 0.607c9.926-31.702 37.547-54.913 71.017-58.213l0.343-0.027c34.538-5.725 74.337-8.996 114.901-8.996 2.58 0 5.158 0.013 7.732 0.040l-0.393-0.003c2.118-0.022 4.622-0.034 7.128-0.034 40.637 0 80.51 3.271 119.371 9.563l-4.259-0.569c33.71 3.584 61.212 26.682 71.195 57.647l0.165 0.593c7.406 13.928 11.963 30.376 12.476 47.838l0.004 0.162c0 47.040-58.24 52.8-89.28 52.8zM1064.96 715.84h-87.040c-28.8 0-32-6.4-32-14.4 1.433-7.76 4.342-14.65 8.44-20.666l-0.12 0.186c4.445-6.022 9.866-11.034 16.076-14.898l0.244-0.142c8.344-3.99 18.131-6.344 28.461-6.4l0.019-0h74.24c12.48 0 20.8 2.56 20.8 14.4s-6.080 42.88-29.12 42.88zM1104 491.84c-0.63 24.312-13.059 45.593-31.751 58.399l-0.249 0.161c-16.303 10.122-36.083 16.122-57.265 16.122-5.424 0-10.756-0.393-15.969-1.153l0.593 0.071c-5.029 0.221-10.928 0.346-16.857 0.346-28.002 0-55.349-2.806-81.774-8.151l2.631 0.444c-10.145-2.694-17.499-11.794-17.499-22.613 0-4.279 1.151-8.289 3.159-11.738l-0.060 0.111c17.090-20.587 38.503-36.975 62.902-47.881l1.098-0.439c32.453-18.735 71.38-29.788 112.888-29.788 1.263 0 2.523 0.010 3.782 0.031l-0.19-0.002c36.16 0 37.12 15.68 34.56 45.76z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"car"
			],
			defaultCode: 60423,
			grid: 16,
			colorPermutations: {
			},
			width: 1312
		},
		attrs: [
		],
		properties: {
			id: 26,
			order: 2081,
			ligatures: "car",
			prevSize: 15,
			code: 60423,
			name: "car"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 26
	},
	{
		icon: {
			paths: [
				"M1021.221 570.197s2.943 65.39-38.416 90.238h-52.475c7.014-14.312 11.116-31.147 11.116-48.94 0-62.567-50.721-113.287-113.287-113.287s-113.287 50.721-113.287 113.287c0 17.793 4.102 34.628 11.411 49.61l-0.295-0.67h-420.782c7.014-14.312 11.116-31.147 11.116-48.94 0-62.567-50.721-113.287-113.287-113.287s-113.287 50.721-113.287 113.287c0 17.793 4.102 34.628 11.411 49.61l-0.295-0.67s-60.812 2.779-80.756-17.655-16.347-152.685-16.347-152.685c8.388-3.396 14.913-9.921 18.23-18.090l0.079-0.219c4.741-13.405 13.405-59.504 13.405-59.504s203.688-77.977 310.6-90.401 130.943-6.049 165.926-1.308c97.267 8.664 248.317 105.604 248.317 105.604s171.811 22.069 238.181 76.833c10.873 19.411 18.835 42.032 22.577 66.049l0.146 1.139zM521.808 336.756c-24.41-4.29-52.516-6.743-81.194-6.743-30.699 0-60.742 2.811-89.884 8.188l3.028-0.464s-101.844 18.309-134.539 34.493c-12.587 8.501 0 21.088 0 21.088 27.464 27.464 347.872 49.042 495.489 36.618-2.452-10.789-112.143-76.833-192.899-93.18zM296.215 611.556c-0.001 52.003-42.158 94.159-94.161 94.159s-94.161-42.157-94.161-94.161c0-51.774 41.785-93.788 93.471-94.159h0.036c0.194-0.001 0.424-0.002 0.654-0.002 52.004 0 94.161 42.157 94.161 94.161 0 0.001 0 0.002 0 0.002v0zM201.4 550.089c-33.946 0-61.466 27.52-61.466 61.466s27.52 61.466 61.466 61.466c33.946 0 61.466-27.52 61.466-61.466v0c0-33.946-27.52-61.466-61.466-61.466v0zM922.156 611.556c0 52.004-42.157 94.161-94.161 94.161s-94.161-42.157-94.161-94.161c0-52.004 42.157-94.161 94.161-94.161v0c52.004 0 94.161 42.157 94.161 94.161v0zM827.995 550.089c-33.946 0-61.466 27.52-61.466 61.466s27.52 61.466 61.466 61.466c33.946 0 61.466-27.52 61.466-61.466v0c0-33.946-27.52-61.466-61.466-61.466v0z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"car-side"
			],
			defaultCode: 59659,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 27,
			order: 2082,
			ligatures: "car-side",
			prevSize: 15,
			code: 59659,
			name: "car-side"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 27
	},
	{
		icon: {
			paths: [
				"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM448 794.51l-237.254-237.256 90.51-90.508 146.744 146.744 306.746-306.746 90.508 90.51-397.254 397.256z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"checkbox-checked"
			],
			defaultCode: 61035,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 28,
			order: 2083,
			ligatures: "checkbox-checked",
			prevSize: 15,
			code: 61035,
			name: "checkbox-checked"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 28
	},
	{
		icon: {
			paths: [
				"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM896 896h-768v-768h768v768z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"checkbox-unchecked",
				"square"
			],
			defaultCode: 61036,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 29,
			order: 2084,
			ligatures: "checkbox-unchecked",
			prevSize: 15,
			code: 61036,
			name: "checkbox-unchecked"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 29
	},
	{
		icon: {
			paths: [
				"M896 160l-544 544-224-224-96 96 320 320 640-640z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"checkmark"
			],
			defaultCode: 60782,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 30,
			order: 2085,
			ligatures: "checkmark",
			prevSize: 15,
			code: 60782,
			name: "checkmark"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 30
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM416 770l-180-214 66-66 114 112 330-288 46 46-376 410z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"checkmark-circle",
				"radio-checked-2"
			],
			defaultCode: 61043,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 31,
			order: 2086,
			ligatures: "checkmark-circle",
			prevSize: 15,
			code: 61043,
			name: "checkmark-circle"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 31
	},
	{
		icon: {
			paths: [
				"M1024 352l-128-128-384 384-384-384-128 128 511.998 512 512.002-512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-down"
			],
			defaultCode: 60861,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 32,
			order: 2182,
			ligatures: "chevron-down",
			prevSize: 15,
			code: 60861,
			name: "chevron-down"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 32
	},
	{
		icon: {
			paths: [
				"M1024 352l-96-96-416 416-416-416-96 96 511.998 512 512.002-512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-down-light"
			],
			defaultCode: 60866,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 7,
			order: 2178,
			ligatures: "arrow-down",
			prevSize: 15,
			code: 60866,
			name: "chevron-down-light"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 33
	},
	{
		icon: {
			paths: [
				"M1024 268.935h-320.168l-191.832 182.761-192.168-182.761h-319.832l512 486.131 512-486.131z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-down-chamfered"
			],
			defaultCode: 59685,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 33,
			order: 2184,
			ligatures: "chevron-down-chamfered",
			prevSize: 15,
			code: 59685,
			name: "chevron-down-chamfered"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 34
	},
	{
		icon: {
			paths: [
				"M672 1024l128-128-384-384 384-384-128-128-512 511.998 512 512.002z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-left"
			],
			defaultCode: 60865,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 34,
			order: 2183,
			ligatures: "chevron-left",
			prevSize: 15,
			code: 60865,
			name: "chevron-left"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 35
	},
	{
		icon: {
			paths: [
				"M672 1024l96-96-416-416 416-416-96-96-512 511.998 512 512.002z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-left-light"
			],
			defaultCode: 60872,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 8,
			order: 2179,
			ligatures: "arrow-left",
			prevSize: 15,
			code: 60872,
			name: "chevron-left-light"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 36
	},
	{
		icon: {
			paths: [
				"M352 0l-128 128 384 384-384 384 128 128 512-511.998-512-512.002z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-right"
			],
			defaultCode: 60857,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 35,
			order: 2181,
			ligatures: "chevron-right",
			prevSize: 15,
			code: 60857,
			name: "chevron-right"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 37
	},
	{
		icon: {
			paths: [
				"M352 0l-96 96 416 416-416 416 96 96 512-511.998-512-512.002z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-right-light"
			],
			defaultCode: 60862,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 9,
			order: 2177,
			ligatures: "arrow-right",
			prevSize: 15,
			code: 60862,
			name: "chevron-right-light"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 38
	},
	{
		icon: {
			paths: [
				"M0 672l128 128 384-384 384 384 128-128-511.998-512-512.002 512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-up"
			],
			grid: 16,
			colorPermutations: {
			},
			defaultCode: 60853
		},
		attrs: [
		],
		properties: {
			id: 36,
			order: 2180,
			ligatures: "chevron-up",
			prevSize: 15,
			name: "chevron-up",
			code: 60853
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 39
	},
	{
		icon: {
			paths: [
				"M0 672l96 96 416-416 416 416 96-96-511.998-512-512.002 512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-up-light"
			],
			defaultCode: 60858,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 10,
			order: 2176,
			ligatures: "arrow-up",
			prevSize: 15,
			code: 60858,
			name: "chevron-up-light"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 40
	},
	{
		icon: {
			paths: [
				"M256 256h512v-128h-128c0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128h-128v128zM512 64c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64s28.654-64 64-64z",
				"M928 128h-96v160c0 17.672-14.326 32-32 32h-576c-17.672 0-32-14.328-32-32v-160h-96c-17.672 0-32 14.328-32 32v832c0 17.674 14.328 32 32 32h832c17.674 0 32-14.326 32-32v-832c0-17.672-14.326-32-32-32z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"clipboard",
				"board"
			],
			defaultCode: 60496,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 37,
			order: 2087,
			prevSize: 15,
			code: 60496,
			ligatures: "clipboard",
			name: "clipboard"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 41
	},
	{
		icon: {
			paths: [
				"M256 256h512v-128h-128c0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128h-128v128zM512 64c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64s28.654-64 64-64z",
				"M928 128h-96v160c0 17.672-14.326 32-32 32h-576c-17.672 0-32-14.328-32-32v-160h-96c-17.672 0-32 14.328-32 32v832c0 17.674 14.328 32 32 32h832c17.674 0 32-14.326 32-32v-832c0-17.672-14.326-32-32-32zM448 922.51l-205.254-237.254 58.508-58.51 146.746 114.744 274.742-242.744 58.514 58.508-333.256 365.256z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"clipboard",
				"board",
				"signup",
				"register",
				"agreement"
			],
			defaultCode: 60497,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 38,
			order: 2088,
			prevSize: 15,
			code: 60497,
			ligatures: "clipboard-checked",
			name: "clipboard-checked"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 42
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM658.744 749.256l-210.744-210.746v-282.51h128v229.49l173.256 173.254-90.512 90.512z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"clock",
				"time",
				"schedule"
			],
			defaultCode: 59982,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 39,
			order: 2089,
			prevSize: 15,
			code: 59982,
			ligatures: "clock",
			name: "clock"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 43
	},
	{
		icon: {
			paths: [
				"M512 544l-224 224h160v192h128v-192h160l-224-224zM892.216 514.542c2.49-11.29 3.784-22.87 3.784-34.542 0-88.224-71.776-160-160-160-13.956 0-27.796 1.83-41.164 5.378-24.838-77.286-97.404-133.378-182.836-133.378-86.654 0-160.886 58.042-184.312 138.118-22.982-6.66-47.052-10.118-71.688-10.118-141.158 0-256 114.84-256 256 0 61.986 22.444 121.798 63.2 168.42 40.354 46.164 95.852 76.346 156.266 84.988 1.538 0.218 3.064 0.326 4.572 0.326 15.666 0 29.354-11.514 31.638-27.472 2.502-17.496-9.652-33.708-27.146-36.208-45.262-6.474-86.864-29.116-117.144-63.754-30.558-34.956-47.386-79.81-47.386-126.3 0-105.87 86.13-192 192-192 52.024 0 100.73 20.466 137.146 57.63 12.368 12.624 32.63 12.83 45.252 0.458 12.624-12.37 12.83-32.628 0.458-45.252-15.676-15.998-33.070-29.66-51.76-40.848 12.84-57.42 64.304-99.988 124.904-99.988 70.58 0 128 57.42 128 128 0 8.706-0.876 17.398-2.602 25.832-3.542 17.316 7.624 34.222 24.938 37.764 2.164 0.444 4.32 0.656 6.448 0.656 14.884 0 28.218-10.442 31.318-25.592 2.218-10.854 3.494-21.972 3.812-33.126 10.244-3.624 21.096-5.534 32.086-5.534 52.936 0 96 43.066 96 96 0 10.964-1.88 21.784-5.484 32h-26.516c-17.674 0-32 14.326-32 32s14.326 32 32 32h64c52.934 0 96 43.066 96 96s-43.066 96-96 96h-64c-17.674 0-32 14.326-32 32s14.326 32 32 32h64c88.224 0 160-71.776 160-160 0-78.594-56.976-144.086-131.784-157.458z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cloud-upload"
			],
			defaultCode: 60533,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 40,
			order: 2090,
			ligatures: "cloud-upload",
			prevSize: 15,
			code: 60533,
			name: "cloud-upload"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 44
	},
	{
		icon: {
			paths: [
				"M614.4 694.126c7.314 0 7.314 0 14.629 7.314l36.571 36.571c-24.765 31.702-56.747 56.642-93.545 72.55l-1.541 0.593c-32.514 14.386-70.433 22.762-110.309 22.762-7.513 0-14.957-0.297-22.32-0.881l0.972 0.062c-1.139 0.014-2.485 0.022-3.833 0.022-43.303 0-84.724-8.058-122.845-22.756l2.335 0.792c-37.24-15.833-68.889-38.102-94.961-65.696l-0.124-0.133c-29.39-30.016-52.002-66.789-65.282-107.764l-0.547-1.951c-13.902-35.781-21.957-77.195-21.957-120.491 0-1.097 0.005-2.193 0.015-3.288l-0.001 0.167c0.158-47.17 8.18-92.415 22.821-134.564l-0.879 2.906c15.662-40.086 37.978-74.384 65.907-103.212l-0.078 0.081c28.552-27.779 62.597-50.081 100.33-65.102l2.070-0.727c39.242-13.763 84.487-21.785 131.585-21.943l0.073-0c1.089-0.014 2.374-0.022 3.661-0.022 40.85 0 79.814 8.069 115.388 22.701l-2.020-0.736c34.205 14.129 63.384 33.924 87.754 58.496l0.018 0.018-29.257 36.571-7.314 7.314h-14.629c-7.314 0-7.314 0-14.629-7.314l-7.314-7.314-21.943-14.629c-7.314-7.314-14.629-7.314-29.257-14.629-9.877-2.746-22.256-5.302-34.875-7.114l-1.696-0.2c-11.976-4.965-25.884-7.848-40.466-7.848-3.78 0-7.515 0.194-11.196 0.572l0.462-0.038c-32.13 0.342-62.298 8.42-88.83 22.453l1.058-0.51c-29.399 10.622-54.094 28.25-72.921 50.925l-0.222 0.275c-20.579 20.733-37.733 44.902-50.518 71.564l-0.682 1.579c-8.025 32.676-13.283 70.591-14.603 109.505l-0.025 0.941c0.823 36.749 6.11 71.906 15.34 105.43l-0.711-3.030c13.536 30.878 30.722 57.438 51.467 80.763l-0.267-0.306c20.733 20.579 44.902 37.733 71.564 50.518l1.579 0.682c21.676 9.591 46.956 15.174 73.539 15.174 5.009 0 9.971-0.198 14.88-0.587l-0.648 0.041h51.2c14.629 0 29.257-7.314 43.886-7.314s21.943-7.314 36.571-14.629c13.118-5.868 23.389-16.14 29.112-28.896l0.145-0.361c-7.314-8.046 0-15.36 7.314-15.36z",
				"M797.257 562.469v263.314h-80.457v-629.029h175.543c37.015 1.405 72.12 6.658 105.829 15.382l-3.429-0.753c27.961 8.305 52.307 20.809 73.72 36.989l-0.577-0.418c15.699 17.355 30.171 36.479 42.892 56.811l0.994 1.703c7.93 21.572 13.171 46.516 14.599 72.476l0.029 0.667c0.288 3.439 0.452 7.443 0.452 11.485 0 16.834-2.844 33.004-8.077 48.056l0.311-1.027c-5.58 20.067-15.725 37.317-29.281 51.225l0.024-0.025c-13.65 15.883-30.817 28.352-50.323 36.257l-0.877 0.314c-18.308 13.227-41.064 21.364-65.69 21.94l-0.139 0.003c13.118 5.868 23.389 16.14 29.112 28.896l0.145 0.361 182.857 248.686h-73.143c-14.146-0.268-26.955-5.779-36.611-14.664l0.039 0.036-168.229-234.057c-7.314-7.314-7.314-14.629-14.629-14.629s-14.629-7.314-29.257-7.314zM797.257 496.64h87.771c3.239 0.185 7.028 0.29 10.841 0.29 19.579 0 38.509-2.777 56.418-7.959l-1.431 0.354c16.858-6.465 31.316-13.844 44.858-22.526l-0.972 0.583c13.37-8.665 23.571-21.227 29.092-36.066l0.165-0.506c4.812-12.726 7.598-27.438 7.598-42.8 0-2.956-0.103-5.887-0.306-8.791l0.022 0.391c-1.444-33.833-15.099-64.222-36.636-87.109l0.065 0.069c-28.793-18.462-63.927-29.429-101.623-29.429-2.846 0-5.677 0.063-8.492 0.186l0.401-0.014h-87.771z"
			],
			attrs: [
			],
			width: 1317,
			isMulticolor: false,
			isMulticolor2: false,
			grid: 16,
			tags: [
				"CR"
			],
			colorPermutations: {
			},
			defaultCode: 59657
		},
		attrs: [
		],
		properties: {
			order: 2091,
			id: 41,
			name: "condition-report",
			prevSize: 15,
			code: 59657,
			ligatures: "condition-report"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 45
	},
	{
		icon: {
			paths: [
				"M928 128h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM192 768h-64v-128h64v128zM320 768h-64v-128h64v128zM448 768h-64v-128h64v128zM992 512h-960v-192h960v192z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"credit-card"
			],
			defaultCode: 59926,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 42,
			order: 2092,
			ligatures: "credit-card",
			prevSize: 15,
			code: 59926,
			name: "credit-card"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 46
	},
	{
		icon: {
			paths: [
				"M893.254 221.254l-90.508-90.508-290.746 290.744-290.746-290.744-90.508 90.506 290.746 290.748-290.746 290.746 90.508 90.508 290.746-290.746 290.746 290.746 90.508-90.51-290.744-290.744z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cross"
			],
			defaultCode: 60778,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 43,
			order: 2093,
			ligatures: "cross",
			prevSize: 15,
			code: 60778,
			name: "cross"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 47
	},
	{
		icon: {
			paths: [
				"M781.256 690.744l-90.512 90.512-178.744-178.746-178.746 178.744-90.51-90.51 178.746-178.744-178.744-178.746 90.508-90.508 178.746 178.744 178.744-178.746 90.512 90.51-178.746 178.746 178.746 178.744z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cross-small"
			],
			defaultCode: 60779,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 44,
			order: 2094,
			ligatures: "cross-small",
			prevSize: 15,
			code: 60779,
			name: "cross-small"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 48
	},
	{
		icon: {
			paths: [
				"M1200.64 258.56h-72.96c-0.308-0.013-0.669-0.021-1.032-0.021-8.261 0-15.62 3.865-20.367 9.885l-0.042 0.055c-8.32 11.52-13.76 37.12-21.12 37.12h-24.96c-7.167-18.8-13.949-33.878-21.447-48.529l1.287 2.769c-11.306-23.498-21.961-42.68-33.549-61.218l1.549 2.658s-17.6-24-27.52-34.56c-13.464-15.603-32.122-26.399-53.263-29.696l-0.497-0.064c-30.72-5.12-67.2-8.96-67.2-8.96l-82.24-3.84h-214.72l-82.56 3.84s-37.76 3.52-66.56 8.32c-21.638 3.361-40.296 14.157-53.664 29.646l-0.096 0.114c-9.92 10.56-27.52 34.56-27.52 34.56-10.039 15.879-20.694 35.061-30.35 54.82l-1.65 3.74c-6.21 11.881-12.993 26.959-19.014 42.418l-1.146 3.342h-32c-7.36 0-12.8-25.6-21.12-37.12-4.788-6.076-12.147-9.941-20.408-9.941-0.363 0-0.724 0.007-1.083 0.022l0.051-0.002h-74.88c-0.217-0.006-0.473-0.009-0.73-0.009-15.552 0-28.16 12.608-28.16 28.16 0 0.792 0.033 1.576 0.097 2.351l-0.007-0.102v27.2c0 17.28 29.44 42.56 56.96 43.2h97.28l-39.68 35.52c-32 30.080-54.72 40.32-54.72 96 0 100.8 7.36 177.28 7.36 177.28l6.080 64c0.933 9.082 2.286 17.147 4.103 25.035l-0.263-1.355v113.6c-0 0.017-0 0.037-0 0.058 0 16.998 13.253 30.9 29.989 31.938l0.091 0.005h135.68c16.683-1.206 29.76-15.037 29.76-31.922 0-0.028-0-0.055-0-0.083l0 0.004v-57.92h585.6v57.28c-0 0.023-0 0.051-0 0.078 0 16.885 13.077 30.715 29.656 31.915l0.104 0.006h136c16.683-1.206 29.76-15.037 29.76-31.922 0-0.028-0-0.055-0-0.083l0 0.004v-91.52c4.828-13.244 8.538-28.722 10.461-44.749l0.099-1.011 6.080-64s7.36-76.48 7.36-177.28c0-54.4-22.4-64-54.72-96l-38.080-34.88h87.040c27.52 0 57.28-25.92 57.28-43.2v-27.52c0.012-0.306 0.018-0.665 0.018-1.026 0-15.729-12.751-28.48-28.48-28.48-0.682 0-1.359 0.024-2.029 0.071l0.090-0.005zM330.24 304.96c9.832-23.959 20.558-44.374 32.932-63.629l-0.932 1.549c8.807-13.128 18.506-24.555 29.343-34.789l0.097-0.091c19.404-10.87 42.352-17.818 66.791-19.182l0.409-0.018c59.2-6.4 155.2-6.4 155.2-6.4h106.24s96 0 155.52 6.4c24.738 1.374 47.579 8.324 67.662 19.604l-0.782-0.404c11.044 10.255 20.755 21.694 29.007 34.182l0.433 0.698c11.442 17.706 22.168 38.121 31.049 59.496l0.951 2.584c14.4 35.2-10.56 44.48-23.36 45.12s-201.28 0-201.28 0l-111.68-1.6-112.96 3.52s-188.48 0-201.28 0-37.76-11.84-23.36-47.040zM345.6 716.8h-87.040c-21.12 0-28.8-29.76-28.8-41.92s8.32-14.080 20.8-14.4h74.24c10.349 0.056 20.136 2.41 28.893 6.577l-0.413-0.177c6.53 3.895 11.972 8.928 16.211 14.878l0.109 0.162c3.978 5.83 6.887 12.72 8.269 20.148l0.051 0.332c0 8-3.52 14.4-32.32 14.4zM420.48 556.8c-23.847 4.895-51.254 7.698-79.315 7.698-5.868 0-11.707-0.123-17.515-0.365l0.831 0.028c-4.636 0.688-9.987 1.080-15.429 1.080-21.27 0-41.14-5.998-58.009-16.395l0.478 0.274c-18.941-12.967-31.37-34.248-31.998-58.465l-0.002-0.095c-2.24-30.080-1.6-45.76 35.52-46.080 1.117-0.020 2.435-0.031 3.756-0.031 41.454 0 80.325 11.055 113.827 30.378l-1.103-0.587c25.492 11.356 46.902 27.741 63.771 48.036l0.229 0.284c2.097 3.463 3.338 7.647 3.338 12.121 0 11.198-7.773 20.58-18.217 23.047l-0.161 0.032zM784.32 699.2h-233.6c-32 0-88-5.76-88-52.8 0.086-17.159 4.214-33.333 11.479-47.647l-0.279 0.607c10.061-30.947 37.013-53.605 69.705-57.246l0.375-0.034c34.538-5.725 74.337-8.996 114.901-8.996 2.58 0 5.158 0.013 7.732 0.040l-0.393-0.003c2.118-0.022 4.622-0.034 7.128-0.034 40.637 0 80.51 3.271 119.371 9.563l-4.259-0.569c33.71 3.584 61.212 26.682 71.195 57.647l0.165 0.593c6.747 13.752 10.748 29.913 10.88 46.995l0 0.045c1.28 47.040-55.36 52.8-86.4 52.8zM1074.56 715.84h-87.040c-28.8 0-32-6.4-32-14.4 1.433-7.76 4.342-14.65 8.44-20.666l-0.12 0.186c4.445-6.022 9.866-11.034 16.076-14.898l0.244-0.142c8.344-3.99 18.131-6.344 28.461-6.4l0.019-0h74.24c12.48 0 20.8 2.56 20.8 14.4s-7.68 42.88-29.12 42.88zM1113.6 491.84c-0.63 24.312-13.059 45.593-31.751 58.399l-0.249 0.161c-16.303 10.122-36.083 16.122-57.265 16.122-5.424 0-10.756-0.393-15.969-1.153l0.593 0.071c-5.029 0.221-10.928 0.346-16.857 0.346-28.002 0-55.349-2.806-81.774-8.151l2.631 0.444c-10.145-2.694-17.499-11.794-17.499-22.613 0-4.279 1.151-8.289 3.159-11.738l-0.060 0.111c17.090-20.587 38.503-36.975 62.902-47.881l1.098-0.439c32.453-18.735 71.38-29.788 112.888-29.788 1.263 0 2.523 0.010 3.782 0.031l-0.19-0.002c36.16 0 37.12 15.68 34.56 45.76z",
				"M1265.28 590.72l116.16 138.88v-61.44l117.12 77.44-145.92-155.84 1.28 61.12-88.64-60.16z",
				"M1265.28 496.64l116.16-138.88v61.76l117.12-77.76-145.92 155.84 1.28-61.12-88.64 60.16z",
				"M1330.56 527.040l92.8 64-9.92-37.76 83.52 26.88-113.28-69.44 10.56 37.12-63.68-20.8z"
			],
			attrs: [
			],
			width: 1600,
			isMulticolor: false,
			isMulticolor2: false,
			grid: 16,
			tags: [
				"damages"
			],
			colorPermutations: {
			},
			defaultCode: 59658
		},
		attrs: [
		],
		properties: {
			order: 2095,
			id: 45,
			name: "damages",
			prevSize: 15,
			code: 59658,
			ligatures: "damages"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 49
	},
	{
		icon: {
			paths: [
				"M1024 64v126.4h-512v-126.4h512zM1024 318.4v126.4h-512v-126.4h512zM1024 576v126.4h-1024v-126.4h1024zM1024 832v128h-1024v-128h1024zM238.4 444.8h-99.2c-76.8 0-139.2-62.4-139.2-139.2v-102.4c0-76.8 62.4-139.2 139.2-139.2h99.2c76.8 0 139.2 62.4 139.2 139.2v102.4c1.6 76.8-62.4 139.2-139.2 139.2z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"details"
			],
			defaultCode: 59648,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 46,
			order: 2096,
			ligatures: "details",
			prevSize: 15,
			code: 59648,
			name: "details"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 50
	},
	{
		icon: {
			paths: [
				"M880.86 397.388h-288.282v128.125h256.25v192.188h-256.25v320.313h-128.125v-320.313h-352.344l-96.094-96.094 96.094-96.094h352.344v-128.125h-320.313v-256.25h320.313v-80.078c0-12.813 4.805-24.023 14.414-33.633 9.609-11.211 20.82-14.414 33.633-14.414h32.031c12.813 0 24.023 4.805 33.633 14.414 9.609 8.008 14.414 19.219 14.414 33.633v80.078h288.282l128.125 128.125-128.125 128.125z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"direction"
			],
			defaultCode: 57598,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 47,
			order: 2097,
			ligatures: "direction",
			prevSize: 15,
			code: 57598,
			name: "direction"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 51
	},
	{
		icon: {
			paths: [
				"M480 64c-265.096 0-480 214.904-480 480 0 265.098 214.904 480 480 480 265.098 0 480-214.902 480-480 0-265.096-214.902-480-480-480zM480 928c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384 0 212.078-171.922 384-384 384zM512 512v-128h128v-64h-128v-64h-64v64h-128v256h128v128h-128v64h128v64h64v-64h128.002l-0.002-256h-128zM448 512h-64v-128h64v128zM576.002 704h-64.002v-128h64.002v128z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"coin-dollar",
				"money",
				"cash",
				"currency-dollar"
			],
			defaultCode: 59915,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			order: 2098,
			id: 48,
			prevSize: 15,
			code: 59915,
			ligatures: "dollar-o",
			name: "dollar-o"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 52
	},
	{
		icon: {
			paths: [
				"M692.706 532.48l90.353-90.353v361.412c0.006 0.332 0.009 0.723 0.009 1.114 0 18.455-7.614 35.131-19.872 47.059l-0.015 0.014c-11.61 11.913-27.813 19.302-45.741 19.302-0.649 0-1.295-0.010-1.939-0.029l0.094 0.002h-496.941c-0.651 0.024-1.416 0.037-2.183 0.037-18.013 0-34.3-7.39-45.995-19.303l-0.010-0.010c-12.273-11.942-19.887-28.619-19.887-47.074 0-0.392 0.003-0.783 0.010-1.173l-0.001 0.059v-496.941c-0.006-0.332-0.009-0.723-0.009-1.114 0-18.455 7.614-35.131 19.872-47.059l0.015-0.014c11.601-10.887 27.255-17.574 44.472-17.574 1.307 0 2.606 0.039 3.894 0.115l-0.178-0.008h361.412l-90.353 90.353h-248.772v451.765h451.765zM760.772 148.179c1.672-0.093 3.629-0.146 5.599-0.146 59.215 0 107.219 48.004 107.219 107.219 0 2.17-0.064 4.326-0.192 6.464l0.014-0.295-428.875 428.875h-113.242v-112.64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			grid: 16,
			tags: [
				"edit"
			],
			colorPermutations: {
			},
			defaultCode: 59683
		},
		attrs: [
		],
		properties: {
			order: 2099,
			id: 49,
			name: "edit",
			prevSize: 15,
			code: 59683,
			ligatures: "edit"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 53
	},
	{
		icon: {
			paths: [
				"M1024 0h-416l160 160-192 192 96 96 192-192 160 160z",
				"M1024 1024v-416l-160 160-192-192-96 96 192 192-160 160z",
				"M0 1024h416l-160-160 192-192-96-96-192 192-160-160z",
				"M0 0v416l160-160 192 192 96-96-192-192 160-160z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"enlarge",
				"expand",
				"maximize",
				"fullscreen"
			],
			defaultCode: 60219,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 50,
			order: 2100,
			prevSize: 15,
			code: 60219,
			ligatures: "enlarge",
			name: "enlarge"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 54
	},
	{
		icon: {
			paths: [
				"M928 128h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h832c52.798 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM896 320l-384 288-384-288v-64l384 192 384-192v64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"envelop5"
			],
			defaultCode: 59956,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 51,
			order: 2101,
			ligatures: "envelope",
			prevSize: 15,
			code: 59956,
			name: "envelope"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 55
	},
	{
		icon: {
			paths: [
				"M960 128h-896c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-640c0-35.2-28.8-64-64-64zM896 256v46l-384 226.286-384-226.286v-46h768zM128 768v-354.572l384 226.286 384-226.286v354.572h-768z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"envelop",
				"mail",
				"email",
				"contact",
				"letter"
			],
			defaultCode: 59955,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 52,
			order: 2102,
			prevSize: 15,
			code: 59955,
			ligatures: "envelope-o, envelope2",
			name: "envelope2"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 56
	},
	{
		icon: {
			paths: [
				"M1009.956 915.76v0l-437.074-871.112c-16.742-29.766-38.812-44.648-60.882-44.648s-44.14 14.882-60.884 44.648l-437.074 871.112c-33.486 59.532-5 108.24 63.304 108.24h869.308c68.302 0 96.792-48.708 63.302-108.24zM512 896c-35.346 0-64-28.654-64-64s28.654-64 64-64c35.348 0 64 28.652 64 64s-28.652 64-64 64zM576 640c0 35.346-28.654 64-64 64s-64-28.654-64-64v-192c0-35.346 28.654-64 64-64s64 28.654 64 64v192z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"warning",
				"sign"
			],
			defaultCode: 60753,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 53,
			order: 2103,
			prevSize: 15,
			code: 60753,
			ligatures: "error-triangle",
			name: "error-triangle"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 57
	},
	{
		icon: {
			paths: [
				"M512 192c-223.318 0-416.882 130.042-512 320 95.118 189.958 288.682 320 512 320 223.312 0 416.876-130.042 512-320-95.116-189.958-288.688-320-512-320zM764.45 361.704c60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-89.56 0-176.858-25.486-252.452-73.704-60.158-38.372-111.138-89.772-149.432-150.296 38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.86-7.3-9.96 27.328-15.41 56.822-15.41 87.596 0 141.382 114.616 256 256 256 141.382 0 256-114.618 256-256 0-30.774-5.452-60.268-15.408-87.598 3.978 2.378 7.938 4.802 11.858 7.302v0zM512 416c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.982 96 96z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"eye"
			],
			defaultCode: 60588,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 54,
			order: 2104,
			ligatures: "eye",
			prevSize: 15,
			code: 60588,
			name: "eye"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 58
	},
	{
		icon: {
			paths: [
				"M945.942 14.058c-18.746-18.744-49.136-18.744-67.882 0l-202.164 202.164c-51.938-15.754-106.948-24.222-163.896-24.222-223.318 0-416.882 130.042-512 320 41.122 82.124 100.648 153.040 173.022 207.096l-158.962 158.962c-18.746 18.746-18.746 49.136 0 67.882 9.372 9.374 21.656 14.060 33.94 14.060s24.568-4.686 33.942-14.058l864-864c18.744-18.746 18.744-49.138 0-67.884zM416 320c42.24 0 78.082 27.294 90.92 65.196l-121.724 121.724c-37.902-12.838-65.196-48.68-65.196-90.92 0-53.020 42.98-96 96-96zM110.116 512c38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.862-7.3-9.962 27.328-15.412 56.822-15.412 87.596 0 54.89 17.286 105.738 46.7 147.418l-60.924 60.924c-52.446-36.842-97.202-83.882-131.66-138.342zM768 442c0-27.166-4.256-53.334-12.102-77.898l-321.808 321.808c24.568 7.842 50.742 12.090 77.91 12.090 141.382 0 256-114.618 256-256zM830.026 289.974l-69.362 69.362c1.264 0.786 2.53 1.568 3.786 2.368 60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-38.664 0-76.902-4.76-113.962-14.040l-76.894 76.894c59.718 21.462 123.95 33.146 190.856 33.146 223.31 0 416.876-130.042 512-320-45.022-89.916-112.118-166.396-193.974-222.026z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"eye-blocked"
			],
			defaultCode: 60591,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 55,
			order: 2105,
			ligatures: "eye-blocked",
			prevSize: 15,
			code: 60591,
			name: "eye-blocked"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 59
	},
	{
		icon: {
			paths: [
				"M917.806 229.076c-22.212-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.984 17.78 50.678 41.878 81.374 72.572zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.326 32 32 32h224v624z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"file-empty",
				"file",
				"document",
				"paper",
				"page",
				"new",
				"empty",
				"blank"
			],
			defaultCode: 59806,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			order: 2106,
			id: 56,
			prevSize: 15,
			code: 59806,
			ligatures: "file-empty",
			name: "file-empty"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 60
	},
	{
		icon: {
			paths: [
				"M743.028 384h-135.292l-95.732 141.032-95.742-141.032h-135.29l162.162 242.464-182.972 269.536h251.838v-91.576h-50.156l50.156-74.994 111.396 166.57h140.444l-182.976-269.536 162.164-242.464zM917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"file-excel"
			],
			defaultCode: 61241,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 57,
			order: 2107,
			ligatures: "file-excel",
			prevSize: 15,
			code: 61241,
			name: "file-excel"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 61
	},
	{
		icon: {
			paths: [
				"M842.012 589.48c-13.648-13.446-43.914-20.566-89.972-21.172-31.178-0.344-68.702 2.402-108.17 7.928-17.674-10.198-35.892-21.294-50.188-34.658-38.462-35.916-70.568-85.772-90.576-140.594 1.304-5.12 2.414-9.62 3.448-14.212 0 0 21.666-123.060 15.932-164.666-0.792-5.706-1.276-7.362-2.808-11.796l-1.882-4.834c-5.894-13.592-17.448-27.994-35.564-27.208l-10.916-0.344c-20.202 0-36.664 10.332-40.986 25.774-13.138 48.434 0.418 120.892 24.98 214.738l-6.288 15.286c-17.588 42.876-39.63 86.060-59.078 124.158l-2.528 4.954c-20.46 40.040-39.026 74.028-55.856 102.822l-17.376 9.188c-1.264 0.668-31.044 16.418-38.028 20.644-59.256 35.38-98.524 75.542-105.038 107.416-2.072 10.17-0.53 23.186 10.014 29.212l16.806 8.458c7.292 3.652 14.978 5.502 22.854 5.502 42.206 0 91.202-52.572 158.698-170.366 77.93-25.37 166.652-46.458 244.412-58.090 59.258 33.368 132.142 56.544 178.142 56.544 8.168 0 15.212-0.78 20.932-2.294 8.822-2.336 16.258-7.368 20.792-14.194 8.926-13.432 10.734-31.932 8.312-50.876-0.72-5.622-5.21-12.574-10.068-17.32zM211.646 814.048c7.698-21.042 38.16-62.644 83.206-99.556 2.832-2.296 9.808-8.832 16.194-14.902-47.104 75.124-78.648 105.066-99.4 114.458zM478.434 199.686c13.566 0 21.284 34.194 21.924 66.254s-6.858 54.56-16.158 71.208c-7.702-24.648-11.426-63.5-11.426-88.904 0 0-0.566-48.558 5.66-48.558v0zM398.852 637.494c9.45-16.916 19.282-34.756 29.33-53.678 24.492-46.316 39.958-82.556 51.478-112.346 22.91 41.684 51.444 77.12 84.984 105.512 4.186 3.542 8.62 7.102 13.276 10.65-68.21 13.496-127.164 29.91-179.068 49.862v0zM828.902 633.652c-4.152 2.598-16.052 4.1-23.708 4.1-24.708 0-55.272-11.294-98.126-29.666 16.468-1.218 31.562-1.838 45.102-1.838 24.782 0 32.12-0.108 56.35 6.072 24.228 6.18 24.538 18.734 20.382 21.332v0zM917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"file-pdf"
			],
			defaultCode: 61238,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 58,
			order: 2108,
			ligatures: "file-pdf",
			prevSize: 15,
			code: 61238,
			name: "file-pdf"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 62
	},
	{
		icon: {
			paths: [
				"M917.806 229.076c-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0 0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.98 17.78 50.678 41.878 81.374 72.572v0 0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.322 32 32 32h224v624zM192 448v448h640v-448h-640zM384 832h-128v-128h128v128zM384 640h-128v-128h128v128zM576 832h-128v-128h128v128zM576 640h-128v-128h128v128zM768 832h-128v-128h128v128zM768 640h-128v-128h128v128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"file-spreadsheet"
			],
			defaultCode: 59845,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 59,
			order: 2109,
			ligatures: "file-spreadsheet",
			prevSize: 15,
			code: 59845,
			name: "file-spreadsheet"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 63
	},
	{
		icon: {
			paths: [
				"M917.806 229.076c-22.212-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.984 17.78 50.678 41.878 81.374 72.572zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.326 32 32 32h224v624z",
				"M736 832h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
				"M736 704h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
				"M736 576h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"file-text",
				"file",
				"document",
				"list",
				"paper",
				"page"
			],
			defaultCode: 59822,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 60,
			order: 2110,
			prevSize: 15,
			code: 59822,
			ligatures: "file-text",
			name: "file-text"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 64
	},
	{
		icon: {
			paths: [
				"M917.806 357.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-368c-44.114 0-80 35.888-80 80v736c0 44.112 35.886 80 80 80h608c44.112 0 80-35.888 80-80v-496c0-14.332-4.372-39.35-42.194-90.924zM785.374 302.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-608c-8.672 0-16-7.328-16-16v-736c0-8.672 7.328-16 16-16 0 0 367.956-0.002 368 0v224c0 17.672 14.324 32 32 32h224v496zM602.924 42.196c-51.574-37.822-76.592-42.196-90.924-42.196h-368c-44.112 0-80 35.888-80 80v736c0 38.632 27.528 70.958 64 78.39v-814.39c0-8.672 7.328-16 16-16h486.876c-9.646-7.92-19.028-15.26-27.952-21.804z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"files-empty"
			],
			defaultCode: 59807,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 61,
			order: 2111,
			ligatures: "files-empty",
			prevSize: 15,
			code: 59807,
			name: "files-empty"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 65
	},
	{
		icon: {
			paths: [
				"M0 128l384 384v384l256-64v-320l384-384z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"filter"
			],
			defaultCode: 61064,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 62,
			order: 2112,
			ligatures: "filter",
			prevSize: 15,
			code: 61064,
			name: "filter"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 66
	},
	{
		icon: {
			paths: [
				"M224 0c-106.040 0-192 100.288-192 224 0 105.924 63.022 194.666 147.706 217.998l-31.788 518.124c-2.154 35.132 24.882 63.878 60.082 63.878h32c35.2 0 62.236-28.746 60.082-63.878l-31.788-518.124c84.684-23.332 147.706-112.074 147.706-217.998 0-123.712-85.96-224-192-224zM869.334 0l-53.334 320h-40l-26.666-320h-26.668l-26.666 320h-40l-53.334-320h-26.666v416c0 17.672 14.326 32 32 32h83.338l-31.42 512.122c-2.154 35.132 24.882 63.878 60.082 63.878h32c35.2 0 62.236-28.746 60.082-63.878l-31.42-512.122h83.338c17.674 0 32-14.328 32-32v-416h-26.666z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"spoon-knife",
				"food",
				"restaurant"
			],
			defaultCode: 60345,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 63,
			order: 2113,
			prevSize: 15,
			code: 60345,
			ligatures: "fork-spoon",
			name: "fork-spoon"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 67
	},
	{
		icon: {
			paths: [
				"M950.626 265.372l-128-128c-6-6-14.14-9.372-22.626-9.372h-64c-17.674 0-32 14.328-32 32s14.326 32 32 32h34.744l64 64h-34.744c-17.674 0-32 14.328-32 32v128c0 17.672 14.326 32 32 32h96v256c0 35.29-28.71 64-64 64s-64-28.71-64-64v-160c0-17.674-14.326-32-32-32h-96v-352c0-52.812-43.188-96-96-96h-384c-52.812 0-96 43.188-96 96v800h-64v64h704v-64h-64v-384h64v128c0 70.58 57.42 128 128 128s128-57.42 128-128v-416c0-8.488-3.372-16.626-9.374-22.628zM128 352v-192c0-17.594 14.406-32 32-32h384c17.624 0 32 14.406 32 32v192c0 17.594-14.376 32-32 32h-384c-17.594 0-32-14.406-32-32zM832 384v-64h64v64h-64z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"gas",
				"fuel",
				"gas-pump",
				"gas-station",
				"oil"
			],
			defaultCode: 60426,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 64,
			order: 2114,
			prevSize: 15,
			code: 60426,
			ligatures: "fuel",
			name: "fuel"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 68
	},
	{
		icon: {
			paths: [
				"M1010.174 915.75l-548.634-499.458 25.534-25.598c20.894-20.954 32.188-48.030 33.918-75.61 1.002-0.45 2.002-0.912 2.958-1.442l102.99-64.402c13.934-16.392 12.916-42.268-2.284-57.502l-179.12-179.608c-15.19-15.234-40.998-16.262-57.344-2.284l-64.236 103.268c-0.526 0.966-0.99 1.966-1.44 2.974-27.502 1.736-54.5 13.056-75.398 34.006l-97.428 97.702c-20.898 20.956-32.184 48.026-33.918 75.604-1.004 0.45-2.004 0.916-2.964 1.446l-102.986 64.406c-13.942 16.39-12.916 42.264 2.276 57.496l179.12 179.604c15.194 15.238 40.996 16.262 57.35 2.286l64.228-103.27c0.528-0.958 0.988-1.96 1.442-2.966 27.502-1.738 54.504-13.050 75.398-34.004l28.292-28.372 498.122 550.114c14.436 15.944 36.7 18.518 49.474 5.712l50.356-50.488c12.764-12.808 10.196-35.132-5.706-49.614z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"gavel"
			],
			defaultCode: 60385,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 65,
			order: 2115,
			ligatures: "gavel",
			prevSize: 15,
			code: 60385,
			name: "gavel"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 69
	},
	{
		icon: {
			paths: [
				"M1024 608.094v-192.188l-146.774-24.462c-5.958-18.132-13.222-35.668-21.694-52.5l86.454-121.034-135.896-135.898-120.826 86.304c-16.91-8.554-34.538-15.888-52.768-21.902l-24.402-146.414h-192.188l-24.402 146.416c-18.23 6.014-35.858 13.348-52.766 21.902l-120.828-86.304-135.898 135.898 86.454 121.036c-8.47 16.83-15.734 34.366-21.692 52.498l-146.774 24.46v192.188l147.118 24.52c5.96 17.968 13.21 35.348 21.642 52.030l-86.748 121.448 135.898 135.896 121.654-86.894c16.602 8.35 33.89 15.528 51.764 21.434l24.578 147.472h192.188l24.578-147.474c17.874-5.906 35.162-13.084 51.766-21.432l121.652 86.892 135.896-135.896-86.744-121.446c8.432-16.682 15.678-34.062 21.64-52.032l147.118-24.518zM512 640c-70.692 0-128-57.306-128-128 0-70.692 57.308-128 128-128 70.694 0 128 57.308 128 128 0 70.694-57.306 128-128 128z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"cog",
				"gear",
				"preferences",
				"settings",
				"generate",
				"control",
				"options"
			],
			defaultCode: 60254,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 66,
			order: 2116,
			prevSize: 15,
			code: 60254,
			ligatures: "gear",
			name: "gear"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 70
	},
	{
		icon: {
			paths: [
				"M448 576v-572.024c-252.562 31.496-448 246.93-448 508.024 0 282.77 229.23 512 512 512 261.094 0 476.53-195.438 508.026-448h-572.026zM809.58 846.888c-82.014 72.942-187.696 113.112-297.58 113.112-60.508 0-119.172-11.836-174.362-35.18-53.34-22.56-101.256-54.874-142.42-96.038-41.166-41.162-73.478-89.080-96.038-142.42-23.344-55.19-35.18-113.854-35.18-174.362 0-109.884 40.17-215.566 113.112-297.578 55.866-62.816 127.634-108.242 206.888-131.85v557.428h557.43c-23.61 79.256-69.036 151.022-131.85 206.888zM512 0c282.77 0 512 229.23 512 512h-512v-512z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"pie-chart",
				"stats",
				"statistics",
				"graph"
			],
			defaultCode: 60290,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 67,
			order: 2117,
			prevSize: 15,
			code: 60290,
			ligatures: "graph-pie",
			name: "graph-pie"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 71
	},
	{
		icon: {
			paths: [
				"M0 0h448v448h-448zM576 0h448v448h-448zM0 576h448v448h-448zM576 576h448v448h-448z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"grid",
				"icons",
				"apps",
				"squares"
			],
			defaultCode: 60511,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 68,
			order: 2118,
			prevSize: 15,
			code: 60511,
			ligatures: "grid",
			name: "grid"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 72
	},
	{
		icon: {
			paths: [
				"M0 0h256v256h-256zM384 0h256v256h-256zM768 0h256v256h-256zM0 384h256v256h-256zM384 384h256v256h-256zM768 384h256v256h-256zM0 768h256v256h-256zM384 768h256v256h-256zM768 768h256v256h-256z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"grid",
				"icons",
				"apps",
				"squares"
			],
			defaultCode: 60506,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 69,
			order: 2119,
			prevSize: 15,
			code: 60506,
			ligatures: "grid-small",
			name: "grid-small"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 73
	},
	{
		icon: {
			paths: [
				"M1024 358.156c0 86.362-37.218 164.030-96.49 217.844h0.49l-320 320c-32 32-64 64-96 64s-64-32-96-64l-319.51-320c-59.272-53.814-96.49-131.482-96.49-217.844 0-162.458 131.698-294.156 294.156-294.156 86.362 0 164.030 37.218 217.844 96.49 53.814-59.272 131.482-96.49 217.844-96.49 162.456 0 294.156 131.698 294.156 294.156z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"heart"
			],
			defaultCode: 60652,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 70,
			order: 2120,
			ligatures: "heart",
			prevSize: 15,
			code: 60652,
			name: "heart"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 74
	},
	{
		icon: {
			paths: [
				"M1024 358.156c0-162.458-131.7-294.156-294.156-294.156-86.362 0-164.030 37.218-217.844 96.49-53.814-59.272-131.482-96.49-217.844-96.49-162.458 0-294.156 131.698-294.156 294.156 0 86.362 37.218 164.030 96.49 217.844h-0.49l320 320c32 32 64 64 96 64s64-32 96-64l319.51-320c59.272-53.814 96.49-131.482 96.49-217.844zM841.468 481.232l-323.978 324.258c-1.678 1.678-3.532 3.532-5.49 5.48-1.96-1.95-3.814-3.802-5.49-5.48l-323.978-324.256c-35.166-31.928-54.532-75.638-54.532-123.078 0-91.618 74.538-166.156 166.156-166.156 47.44 0 91.15 19.366 123.076 54.532l94.768 104.38 94.768-104.378c31.928-35.168 75.636-54.534 123.076-54.534 91.618 0 166.156 74.538 166.156 166.156 0 47.44-19.368 91.15-54.532 123.076z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"heart-o"
			],
			defaultCode: 60651,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 71,
			order: 2121,
			ligatures: "heart-o",
			prevSize: 15,
			code: 60651,
			name: "heart-o"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 75
	},
	{
		icon: {
			paths: [
				"M740.147 947.405c0-38.912 0-304.742 0-319.078 0-49.152-47.514-47.923-105.677-47.923s-105.677 0-105.677 47.923v319.078h-219.136c-0.123 0.003-0.268 0.004-0.414 0.004-10.858 0-19.661-8.802-19.661-19.661 0-0.146 0.002-0.291 0.005-0.436l-0 0.022v-390.349l-64.307 50.79c-3.584 2.607-8.073 4.171-12.927 4.171-0.64 0-1.274-0.027-1.9-0.080l0.082 0.006c-5.543-0.706-10.305-3.582-13.481-7.734l-0.035-0.048-70.042-88.883c-2.627-3.456-4.209-7.831-4.209-12.575 0-0.764 0.041-1.519 0.121-2.263l-0.008 0.092c0.706-5.543 3.582-10.305 7.734-13.481l0.048-0.035 491.93-385.024c3.334-2.687 7.621-4.313 12.288-4.313s8.954 1.626 12.326 4.343l-0.038-0.029 491.52 386.253c4.822 3.704 7.9 9.472 7.9 15.959 0 4.656-1.586 8.942-4.247 12.348l0.033-0.044-70.042 88.883c-3.212 4.201-7.974 7.077-13.417 7.772l-0.1 0.010c-0.651 0.072-1.406 0.113-2.17 0.113-4.745 0-9.12-1.582-12.627-4.247l0.052 0.038-64.307-50.79v390.349c0.003 0.123 0.004 0.268 0.004 0.414 0 10.858-8.802 19.661-19.661 19.661-0.146 0-0.291-0.002-0.436-0.005l0.022 0z"
			],
			attrs: [
			],
			width: 1270,
			isMulticolor: false,
			isMulticolor2: false,
			grid: 16,
			tags: [
				"Home"
			],
			colorPermutations: {
			},
			defaultCode: 59660
		},
		attrs: [
		],
		properties: {
			order: 2122,
			id: 72,
			name: "home",
			prevSize: 15,
			code: 59660,
			ligatures: "home"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 76
	},
	{
		icon: {
			paths: [
				"M959.884 128c0.040 0.034 0.082 0.076 0.116 0.116v767.77c-0.034 0.040-0.076 0.082-0.116 0.116h-895.77c-0.040-0.034-0.082-0.076-0.114-0.116v-767.772c0.034-0.040 0.076-0.082 0.114-0.114h895.77zM960 64h-896c-35.2 0-64 28.8-64 64v768c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-768c0-35.2-28.8-64-64-64v0z",
				"M832 288c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.98 96 96z",
				"M896 832h-768v-128l224-384 256 320h64l224-192z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"image",
				"picture",
				"photo",
				"graphic"
			],
			defaultCode: 59708,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			order: 2123,
			id: 73,
			prevSize: 15,
			code: 59708,
			ligatures: "image",
			name: "image"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 77
	},
	{
		icon: {
			width: 1152,
			paths: [
				"M1088 128h-64v-64c0-35.2-28.8-64-64-64h-896c-35.2 0-64 28.8-64 64v768c0 35.2 28.8 64 64 64h64v64c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-768c0-35.2-28.8-64-64-64zM128 192v640h-63.886c-0.040-0.034-0.082-0.076-0.114-0.116v-767.77c0.034-0.040 0.076-0.082 0.114-0.114h895.77c0.040 0.034 0.082 0.076 0.116 0.116v63.884h-768c-35.2 0-64 28.8-64 64v0zM1088 959.884c-0.034 0.040-0.076 0.082-0.116 0.116h-895.77c-0.040-0.034-0.082-0.076-0.114-0.116v-767.77c0.034-0.040 0.076-0.082 0.114-0.114h895.77c0.040 0.034 0.082 0.076 0.116 0.116v767.768zM960 352c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.98 96 96zM1024 896h-768v-128l224-384 256 320h64l224-192z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"images"
			],
			defaultCode: 59710,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 74,
			order: 2124,
			ligatures: "images",
			prevSize: 15,
			code: 59710,
			name: "images"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 78
	},
	{
		icon: {
			paths: [
				"M1016.988 652.010l-256-320c-11.040-13.798-31.176-16.036-44.978-4.998-13.8 11.040-16.038 31.176-4.998 44.978l248.988 311.234v20.776h-224l-128 128h-192l-128-128h-224v-20.776l248.988-311.234c11.042-13.8 8.804-33.938-4.998-44.978s-33.94-8.804-44.978 4.998l-256 320c-4.538 5.674-7.012 12.724-7.012 19.99v288c0 35.346 28.654 64 64 64h896c35.348 0 64-28.654 64-64v-288c0-7.266-2.472-14.316-7.012-19.99z",
				"M512 736l224-224h-160v-320h-128v320h-160z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"drawer-in",
				"box",
				"inbox",
				"archive",
				"category"
			],
			defaultCode: 60032,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 75,
			order: 2125,
			prevSize: 15,
			code: 60032,
			ligatures: "inbox",
			name: "inbox"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 79
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM448 240c0-26.4 21.6-48 48-48h32c26.4 0 48 21.6 48 48v32c0 26.4-21.6 48-48 48h-32c-26.4 0-48-21.6-48-48v-32zM640 832h-256v-64h64v-256h-64v-64h192v320h64v64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"info"
			],
			grid: 16,
			colorPermutations: {
			},
			defaultCode: 60769
		},
		attrs: [
		],
		properties: {
			id: 76,
			order: 2126,
			ligatures: "info",
			prevSize: 15,
			name: "info",
			code: 60769
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 80
	},
	{
		icon: {
			paths: [
				"M448 304c0-26.4 21.6-48 48-48h32c26.4 0 48 21.6 48 48v32c0 26.4-21.6 48-48 48h-32c-26.4 0-48-21.6-48-48v-32zM640 768h-256v-64h64v-192h-64v-64h192v256h64zM512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"info-o"
			],
			defaultCode: 60772,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 77,
			order: 2127,
			ligatures: "info-o",
			prevSize: 15,
			code: 60772,
			name: "info-o"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 81
	},
	{
		icon: {
			paths: [
				"M768 384h-704v-128h704v-160l224 224-224 224zM256 640h704v128h-704v160l-224-224 224-224z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"transmission",
				"arrows"
			],
			defaultCode: 60995,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 78,
			order: 2128,
			prevSize: 15,
			code: 60995,
			ligatures: "left-right",
			name: "left-right"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 82
	},
	{
		icon: {
			paths: [
				"M440.236 635.766c-13.31 0-26.616-5.076-36.77-15.23-95.134-95.136-95.134-249.934 0-345.070l192-192c46.088-46.086 107.36-71.466 172.534-71.466s126.448 25.38 172.536 71.464c95.132 95.136 95.132 249.934 0 345.070l-87.766 87.766c-20.308 20.308-53.23 20.308-73.54 0-20.306-20.306-20.306-53.232 0-73.54l87.766-87.766c54.584-54.586 54.584-143.404 0-197.99-26.442-26.442-61.6-41.004-98.996-41.004s-72.552 14.562-98.996 41.006l-192 191.998c-54.586 54.586-54.586 143.406 0 197.992 20.308 20.306 20.306 53.232 0 73.54-10.15 10.152-23.462 15.23-36.768 15.23z",
				"M256 1012c-65.176 0-126.45-25.38-172.534-71.464-95.134-95.136-95.134-249.934 0-345.070l87.764-87.764c20.308-20.306 53.234-20.306 73.54 0 20.308 20.306 20.308 53.232 0 73.54l-87.764 87.764c-54.586 54.586-54.586 143.406 0 197.992 26.44 26.44 61.598 41.002 98.994 41.002s72.552-14.562 98.998-41.006l192-191.998c54.584-54.586 54.584-143.406 0-197.992-20.308-20.308-20.306-53.232 0-73.54 20.306-20.306 53.232-20.306 73.54 0.002 95.132 95.134 95.132 249.932 0.002 345.068l-192.002 192c-46.090 46.088-107.364 71.466-172.538 71.466z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"link",
				"chain",
				"url",
				"uri",
				"anchor"
			],
			defaultCode: 60566,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			order: 2129,
			id: 79,
			prevSize: 15,
			code: 60566,
			ligatures: "link",
			name: "link"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 83
	},
	{
		icon: {
			paths: [
				"M384 64h640v128h-640v-128zM384 448h640v128h-640v-128zM384 832h640v128h-640v-128zM0 128c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM0 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM0 896c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"list"
			],
			defaultCode: 60503,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 80,
			order: 2130,
			ligatures: "list",
			prevSize: 15,
			code: 60503,
			name: "list"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 84
	},
	{
		icon: {
			paths: [
				"M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"location"
			],
			defaultCode: 59960,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 81,
			order: 2131,
			ligatures: "location",
			prevSize: 15,
			code: 59960,
			name: "location"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 85
	},
	{
		icon: {
			paths: [
				"M512 0c-176.732 0-320 143.268-320 320 0 320 320 576 320 576s320-256 320-576c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192c106.040 0 192 85.96 192 192s-85.96 192-192 192zM786.256 697.63c-14.182 22.274-28.876 43.38-43.656 63.226 2.346 1.102 4.666 2.216 6.942 3.354 48.67 24.338 70.458 51.582 70.458 67.79s-21.788 43.452-70.458 67.79c-61.28 30.638-147.86 48.21-237.542 48.21s-176.262-17.572-237.542-48.21c-48.672-24.338-70.458-51.582-70.458-67.79s21.786-43.452 70.458-67.79c2.276-1.136 4.596-2.252 6.94-3.354-14.78-19.846-29.474-40.954-43.654-63.226-67.874 34.632-109.744 82.052-109.744 134.37 0 106.040 171.922 192 384 192 212.078 0 384-85.96 384-192 0-52.318-41.87-99.738-109.744-134.37z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"location",
				"map-marker",
				"pin"
			],
			defaultCode: 59961,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 82,
			order: 2132,
			prevSize: 15,
			code: 59961,
			ligatures: "location-area",
			name: "location-area"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 86
	},
	{
		icon: {
			paths: [
				"M592 448h-16v-192c0-105.87-86.13-192-192-192h-128c-105.87 0-192 86.13-192 192v192h-16c-26.4 0-48 21.6-48 48v480c0 26.4 21.6 48 48 48h544c26.4 0 48-21.6 48-48v-480c0-26.4-21.6-48-48-48zM192 256c0-35.29 28.71-64 64-64h128c35.29 0 64 28.71 64 64v192h-256v-192z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"lock",
				"secure",
				"private",
				"encrypted"
			],
			defaultCode: 60240,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 83,
			order: 2133,
			prevSize: 15,
			code: 60240,
			ligatures: "locked",
			name: "locked"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 87
	},
	{
		icon: {
			paths: [
				"M0 512c0 282.624 229.376 512 512 512s512-229.376 512-512c0-282.624-229.376-512-512-512s-512 229.376-512 512zM58.026 512c0-250.539 203.435-453.974 453.974-453.974s453.974 203.435 453.974 453.974-203.435 453.974-453.974 453.974c-250.539 0-453.974-203.435-453.974-453.974zM152.234 512c0 53.931 11.605 104.448 32.768 150.187l51.883-381.611c-52.565 62.123-84.651 143.36-84.651 231.424zM617.131 167.936c-33.451-10.24-68.267-15.702-105.131-15.702-30.037 0-59.392 4.096-87.382 10.923l98.304 326.315 94.208-321.536zM797.355 293.547l42.325 366.592c20.48-45.056 32.085-94.891 32.085-148.139 0-81.92-27.989-157.696-74.411-218.453zM561.152 846.507l-81.92-1.365-121.514-395.947-32.085 370.006c54.614 32.768 118.102 51.883 186.368 51.883 75.094 0 145.408-23.211 202.752-62.805l-30.037-374.101-123.562 412.331z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"manheim-medallion"
			],
			defaultCode: 59653,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 84,
			order: 2134,
			ligatures: "manheim-medallion",
			prevSize: 15,
			code: 59653,
			name: "manheim-medallion"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 88
	},
	{
		icon: {
			paths: [
				"M832 320c0-50.638-39.214-92.090-88.93-95.712 32.592-37.716 31.012-94.754-4.796-130.562-35.806-35.808-92.846-37.388-130.558-4.798-3.626-49.714-45.076-88.928-95.716-88.928s-92.088 39.214-95.712 88.928c-37.714-32.59-94.754-31.008-130.562 4.798-35.806 35.808-37.388 92.846-4.798 130.562-49.712 3.624-88.928 45.074-88.928 95.712s39.214 92.088 88.928 95.712c-32.59 37.714-31.008 94.754 4.798 130.56 26.588 26.588 64.878 34.288 98.274 23.154v422.574l128-128 128 128v-422.572c33.396 11.13 71.686 3.436 98.274-23.154 35.808-35.806 37.388-92.844 4.796-130.56 49.716-3.624 88.93-45.076 88.93-95.714zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192c106.040 0 192 85.96 192 192s-85.96 192-192 192z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"medal"
			],
			defaultCode: 60317,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 85,
			order: 2135,
			ligatures: "medal",
			prevSize: 15,
			code: 60317,
			name: "medal"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 89
	},
	{
		icon: {
			paths: [
				"M1024 429.256c0-200.926-58.792-363.938-131.482-365.226 0.292-0.006 0.578-0.030 0.872-0.030h-82.942c0 0-194.8 146.336-475.23 203.754-8.56 45.292-14.030 99.274-14.030 161.502 0 62.228 5.466 116.208 14.030 161.5 280.428 57.418 475.23 203.756 475.23 203.756h82.942c-0.292 0-0.578-0.024-0.872-0.032 72.696-1.288 131.482-164.298 131.482-365.224zM864.824 739.252c-9.382 0-19.532-9.742-24.746-15.548-12.63-14.064-24.792-35.96-35.188-63.328-23.256-61.232-36.066-143.31-36.066-231.124 0-87.81 12.81-169.89 36.066-231.122 10.394-27.368 22.562-49.266 35.188-63.328 5.214-5.812 15.364-15.552 24.746-15.552 9.38 0 19.536 9.744 24.744 15.552 12.634 14.064 24.796 35.958 35.188 63.328 23.258 61.23 36.068 143.312 36.068 231.122 0 87.804-12.81 169.888-36.068 231.124-10.39 27.368-22.562 49.264-35.188 63.328-5.208 5.806-15.36 15.548-24.744 15.548zM251.812 429.256c0-51.95 3.81-102.43 11.052-149.094-47.372 6.554-88.942 10.324-140.34 10.324-67.058 0-67.058 0-67.058 0l-55.466 94.686v88.17l55.46 94.686c0 0 0 0 67.060 0 51.398 0 92.968 3.774 140.34 10.324-7.236-46.664-11.048-97.146-11.048-149.096zM368.15 642.172l-127.998-24.51 81.842 321.544c4.236 16.634 20.744 25.038 36.686 18.654l118.556-47.452c15.944-6.376 22.328-23.964 14.196-39.084l-123.282-229.152zM864.824 548.73c-3.618 0-7.528-3.754-9.538-5.992-4.87-5.42-9.556-13.86-13.562-24.408-8.962-23.6-13.9-55.234-13.9-89.078 0-33.844 4.938-65.478 13.9-89.078 4.006-10.548 8.696-18.988 13.562-24.408 2.010-2.24 5.92-5.994 9.538-5.994 3.616 0 7.53 3.756 9.538 5.994 4.87 5.42 9.556 13.858 13.56 24.408 8.964 23.598 13.902 55.234 13.902 89.078 0 33.842-4.938 65.478-13.902 89.078-4.004 10.548-8.696 18.988-13.56 24.408-2.008 2.238-5.92 5.992-9.538 5.992z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"bullhorn",
				"megaphone",
				"announcement",
				"advertisement",
				"news"
			],
			defaultCode: 59769,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 86,
			order: 2136,
			prevSize: 15,
			code: 59769,
			ligatures: "megaphone",
			name: "megaphone"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 90
	},
	{
		icon: {
			paths: [
				"M64 192h896v128h-896v-128zM64 448h896v128h-896v-128zM64 704h896v128h-896v-128z"
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"three-bars"
			],
			defaultCode: 60526,
			grid: 16,
			attrs: [
			],
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 87,
			order: 2137,
			ligatures: "menu",
			prevSize: 15,
			code: 60526,
			name: "menu"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 91
	},
	{
		icon: {
			paths: [
				"M0 416v192c0 17.672 14.328 32 32 32h960c17.672 0 32-14.328 32-32v-192c0-17.672-14.328-32-32-32h-960c-17.672 0-32 14.328-32 32z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"minus"
			],
			defaultCode: 60761,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 88,
			order: 2138,
			ligatures: "minus",
			prevSize: 15,
			code: 60761,
			name: "minus"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 92
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM832 576h-640v-128h640v128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"minus-circle"
			],
			grid: 16,
			colorPermutations: {
			},
			defaultCode: 60767
		},
		attrs: [
		],
		properties: {
			id: 89,
			order: 2139,
			ligatures: "minus-circle",
			prevSize: 15,
			name: "minus-circle",
			code: 60767
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 93
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 896c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384zM256 448h512v128h-512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"minus-circle-o"
			],
			defaultCode: 60768,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 90,
			order: 2140,
			ligatures: "minus-circle-o",
			prevSize: 15,
			code: 60768,
			name: "minus-circle-o"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 94
	},
	{
		icon: {
			paths: [
				"M64 448h896v128h-896v-128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"minus3"
			],
			defaultCode: 60766,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 91,
			order: 2141,
			ligatures: "minus-thin, minus3",
			prevSize: 15,
			code: 60766,
			name: "minus3"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 95
	},
	{
		icon: {
			paths: [
				"M736 0h-448c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h448c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM384 48h256v32h-256v-32zM512 960c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM768 768h-512v-640h512v640z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"mobile"
			],
			defaultCode: 60021,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 92,
			order: 2142,
			ligatures: "mobile",
			prevSize: 15,
			code: 60021,
			name: "mobile"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 96
	},
	{
		icon: {
			paths: [
				"M699.733 765.269v-230.059l102.4-102.4v434.859h-614.4v-614.4h434.859l-102.4 102.4h-230.059v409.6zM955.733 99.669v333.141l-128.341-128.341-383.659 384.341-76.459-74.411 383.659-386.389-128.341-128.341z"
			],
			attrs: [
			],
			width: 1092,
			isMulticolor: false,
			isMulticolor2: false,
			grid: 16,
			tags: [
				"Artboard 12"
			],
			colorPermutations: {
			},
			defaultCode: 61125
		},
		attrs: [
		],
		properties: {
			order: 2143,
			id: 93,
			name: "new-window",
			prevSize: 15,
			code: 61125,
			ligatures: "new-window"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 97
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM576 832h-128v-128h128v128zM576 576h-128v-384h128v384z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"notification-circle"
			],
			defaultCode: 60751,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 94,
			order: 2144,
			ligatures: "notification-circle",
			prevSize: 15,
			code: 60751,
			name: "notification-circle"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 98
	},
	{
		icon: {
			paths: [
				"M512 256c-282.77 0-512 229.228-512 512h64c0-116.418 51.806-220.726 133.622-291.148l195.322 244.15c-5.75 14.554-8.944 30.398-8.944 46.998 0 70.694 57.308 128 128 128 70.694 0 128-57.306 128-128s-57.306-128-128-128c-16.6 0-32.444 3.194-46.998 8.946l-241.044-192.84c63.056-45.376 140.426-72.108 224.042-72.108 212.076 0 384 171.92 384 383.998h192c0-282.768-229.23-511.996-512-511.996z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"meter-slow",
				"gauge",
				"dashboard",
				"speedometer",
				"performance"
			],
			defaultCode: 60381,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 95,
			order: 2145,
			prevSize: 15,
			code: 60381,
			ligatures: "odometer",
			name: "odometer"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 99
	},
	{
		icon: {
			paths: [
				"M975.295 499.209c0 9.593-6.395 19.186-31.977 28.779-31.977 12.791-70.349 6.395-108.721-9.593v-223.838c15.988 15.988 35.175 31.977 51.163 51.163 60.756 67.151 92.733 124.71 89.535 153.489zM121.512 160.254c-31.977-9.593-47.965-22.384-54.361-25.582 9.593-6.395 35.175-25.582 102.326-38.372 67.151-15.988 156.687-25.582 249.42-25.582s179.071 9.593 249.42 22.384c67.151 12.791 92.733 31.977 102.326 38.372-9.593 6.395-35.175 25.582-102.326 38.372-67.151 15.988-156.687 22.384-249.42 22.384-15.988 0-31.977 0-47.965 0v211.048c0 25.582-22.384 47.965-47.965 47.965-19.186 0-31.977-9.593-41.57-22.384v67.151c0 51.163-35.175 92.733-76.745 92.733s-76.745-41.57-76.745-92.733v-335.757zM920.935 313.743c-31.977-35.175-63.954-63.954-86.338-83.14v-83.14c0-3.198 0-9.593 0-12.791 0-44.768-44.768-76.745-137.501-99.128-73.547-19.186-172.675-28.779-278.199-28.779s-204.652 9.593-281.397 28.779c-92.733 22.384-137.501 54.361-137.501 99.128 0 6.395 0 9.593 3.198 12.791v738.666c0 54.361 185.466 131.105 415.7 131.105s415.7-76.745 415.7-131.105v-265.408c-143.896-41.57-287.792-195.059-345.351-259.013 0 0-3.198 0-3.198 0-25.582 0-44.768-19.186-44.768-44.768s19.186-44.768 44.768-44.768c25.582 0 44.768 19.186 44.768 44.768 0 0 0 0 0 0s0 3.198 0 3.198 0 6.395-3.198 9.593c12.791 15.988 31.977 35.175 57.558 60.756s57.558 57.558 92.733 86.338c86.338 70.349 159.884 105.524 227.036 105.524 19.186 0 41.57-3.198 57.558-9.593 0 0 0 0 0 0 44.768-15.988 57.558-44.768 60.756-67.151 6.395-44.768-28.779-108.721-102.326-191.861z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"paint-can"
			],
			defaultCode: 59686,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 96,
			order: 2146,
			ligatures: "paint-can",
			prevSize: 15,
			code: 59686,
			name: "paint-can"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 100
	},
	{
		icon: {
			paths: [
				"M864.626 473.162c-65.754-183.44-205.11-348.15-352.626-473.162-147.516 125.012-286.87 289.722-352.626 473.162-40.664 113.436-44.682 236.562 12.584 345.4 65.846 125.14 198.632 205.438 340.042 205.438s274.196-80.298 340.040-205.44c57.27-108.838 53.25-231.962 12.586-345.398zM738.764 758.956c-43.802 83.252-132.812 137.044-226.764 137.044-55.12 0-108.524-18.536-152.112-50.652 13.242 1.724 26.632 2.652 40.112 2.652 117.426 0 228.668-67.214 283.402-171.242 44.878-85.292 40.978-173.848 23.882-244.338 14.558 28.15 26.906 56.198 36.848 83.932 22.606 63.062 40.024 156.34-5.368 242.604z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"droplet",
				"color",
				"water"
			],
			defaultCode: 59700,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 97,
			order: 2147,
			prevSize: 15,
			code: 59700,
			ligatures: "paint-drop",
			name: "paint-drop"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 101
	},
	{
		icon: {
			paths: [
				"M128 128h320v768h-320zM576 128h320v768h-320z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"pause",
				"player"
			],
			defaultCode: 60803,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 98,
			order: 2148,
			prevSize: 15,
			code: 60803,
			ligatures: "pause",
			name: "pause"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 102
	},
	{
		icon: {
			paths: [
				"M752.64 215.68v-96.64h-481.28v96.64h96.64l16 240-112.64 112.64h176.64l44.8 316.8 19.2 19.84 19.2-19.84 44.8-316.8h176.64l-112.64-112.64 16-240h96.64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			grid: 16,
			tags: [
				"pin_1"
			],
			defaultCode: 61581,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			order: 2149,
			id: 99,
			name: "pin",
			prevSize: 15,
			code: 61581,
			ligatures: "pin"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 103
	},
	{
		icon: {
			paths: [
				"M534.4 149.12l-67.84 68.48 67.84 67.84-158.72 181.12h-158.080l124.16 128-192 256v28.16h27.52l256-192 128 124.16v-163.2l181.12-158.080 64 67.84 68.48-67.84zM548.48 526.080l-26.24 141.44-165.76-165.76 139.52-28.16 140.16-138.88 52.48 52.48z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			grid: 16,
			tags: [
				"pin_2"
			],
			defaultCode: 61582,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			order: 2150,
			id: 100,
			name: "pin2",
			prevSize: 15,
			code: 61582,
			ligatures: "pin-angle, pin2"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 104
	},
	{
		icon: {
			paths: [
				"M192 128l640 384-640 384z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"play",
				"player"
			],
			defaultCode: 60802,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 101,
			order: 2151,
			prevSize: 15,
			code: 60802,
			ligatures: "play",
			name: "play"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 105
	},
	{
		icon: {
			paths: [
				"M960 448h-384v-384h-128v384h-384v128h384v384h128v-384h384z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"plus"
			],
			defaultCode: 60765,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 102,
			order: 2152,
			ligatures: "plus",
			prevSize: 15,
			code: 60765,
			name: "plus"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 106
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM576 576v256h-128v-256h-256v-128h256v-256h128v256h256v128h-256z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"plus-circle",
				"add",
				"sum"
			],
			defaultCode: 60759,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 103,
			order: 2153,
			prevSize: 15,
			code: 60759,
			ligatures: "plus-circle2, add5",
			name: "plus-circle"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 107
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 896c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384 0 212.078-171.922 384-384 384zM768 576h-192v192h-128v-192h-192v-128h192v-192h128v192h192z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"plus-circle",
				"add",
				"sum"
			],
			defaultCode: 60758,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 104,
			order: 2154,
			prevSize: 15,
			code: 60758,
			ligatures: "plus-circle-o",
			name: "plus-circle-o"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 108
	},
	{
		icon: {
			paths: [
				"M256 64h512v128h-512v-128zM960 256h-896c-35.2 0-64 28.8-64 64v320c0 35.2 28.794 64 64 64h192v256h512v-256h192c35.2 0 64-28.8 64-64v-320c0-35.2-28.8-64-64-64zM128 448c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.652 64-64 64zM704 896h-384v-320h384v320z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"printer"
			],
			defaultCode: 60006,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 105,
			order: 2155,
			ligatures: "printer",
			prevSize: 15,
			code: 60006,
			name: "printer"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 109
	},
	{
		icon: {
			paths: [
				"M320 64h-256v256h256v-256zM384 0v0 384h-384v-384h384zM128 128h128v128h-128zM960 64h-256v256h256v-256zM1024 0v0 384h-384v-384h384zM768 128h128v128h-128zM320 704h-256v256h256v-256zM384 640v0 384h-384v-384h384zM128 768h128v128h-128zM448 0h64v64h-64zM512 64h64v64h-64zM448 128h64v64h-64zM512 192h64v64h-64zM448 256h64v64h-64zM512 320h64v64h-64zM448 384h64v64h-64zM448 512h64v64h-64zM512 576h64v64h-64zM448 640h64v64h-64zM512 704h64v64h-64zM448 768h64v64h-64zM512 832h64v64h-64zM448 896h64v64h-64zM512 960h64v64h-64zM960 512h64v64h-64zM64 512h64v64h-64zM128 448h64v64h-64zM0 448h64v64h-64zM256 448h64v64h-64zM320 512h64v64h-64zM384 448h64v64h-64zM576 512h64v64h-64zM640 448h64v64h-64zM704 512h64v64h-64zM768 448h64v64h-64zM832 512h64v64h-64zM896 448h64v64h-64zM960 640h64v64h-64zM576 640h64v64h-64zM640 576h64v64h-64zM704 640h64v64h-64zM832 640h64v64h-64zM896 576h64v64h-64zM960 768h64v64h-64zM576 768h64v64h-64zM640 704h64v64h-64zM768 704h64v64h-64zM832 768h64v64h-64zM896 704h64v64h-64zM960 896h64v64h-64zM640 832h64v64h-64zM704 896h64v64h-64zM768 832h64v64h-64zM832 896h64v64h-64zM640 960h64v64h-64zM768 960h64v64h-64zM896 960h64v64h-64z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"qrcode"
			],
			defaultCode: 59896,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 106,
			order: 2156,
			prevSize: 15,
			code: 59896,
			ligatures: "qr-code",
			name: "qr-code"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 110
	},
	{
		icon: {
			paths: [
				"M889.68 166.32c-93.608-102.216-228.154-166.32-377.68-166.32-282.77 0-512 229.23-512 512h96c0-229.75 186.25-416 416-416 123.020 0 233.542 53.418 309.696 138.306l-149.696 149.694h352v-352l-134.32 134.32z",
				"M928 512c0 229.75-186.25 416-416 416-123.020 0-233.542-53.418-309.694-138.306l149.694-149.694h-352v352l134.32-134.32c93.608 102.216 228.154 166.32 377.68 166.32 282.77 0 512-229.23 512-512h-96z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"loop",
				"repeat",
				"player",
				"reload",
				"refresh",
				"update",
				"synchronize",
				"arrows"
			],
			defaultCode: 60839,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			order: 2157,
			id: 107,
			prevSize: 15,
			code: 60839,
			ligatures: "refresh",
			name: "refresh"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 111
	},
	{
		icon: {
			paths: [
				"M640 64c247.424 0 448 200.576 448 448s-200.576 448-448 448v-96c94.024 0 182.418-36.614 248.902-103.098s103.098-154.878 103.098-248.902c0-94.022-36.614-182.418-103.098-248.902s-154.878-103.098-248.902-103.098c-94.022 0-182.418 36.614-248.902 103.098-51.14 51.138-84.582 115.246-97.306 184.902h186.208l-224 256-224-256h164.57c31.060-217.102 217.738-384 443.43-384zM832 448v128h-256v-320h128v192z"
			],
			width: 1088,
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"history",
				"time",
				"archive",
				"past"
			],
			defaultCode: 59980,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 108,
			order: 2158,
			prevSize: 15,
			code: 59980,
			ligatures: "reset-time",
			name: "reset-time"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 112
	},
	{
		icon: {
			paths: [
				"M128 576c0-247.422 200.576-448 448-448s448 200.578 448 448c0 173.374-98.492 323.73-242.566 398.208 106.62-65.99 178.566-190.926 178.566-334.208 0-212.078-157.596-384-352-384-174.412 0-319.154 138.392-347.086 320h123.086l-192 224-192-224h128z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"rotate-ccw",
				"ccw",
				"arrow"
			],
			defaultCode: 60070,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 109,
			order: 2159,
			prevSize: 15,
			code: 60070,
			ligatures: "rotate-left",
			name: "rotate-left"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 113
	},
	{
		icon: {
			paths: [
				"M896 576c0-247.422-200.576-448-448-448s-448 200.578-448 448c0 173.374 98.492 323.73 242.566 398.208-106.62-65.99-178.566-190.926-178.566-334.208 0-212.078 157.596-384 352-384 174.412 0 319.154 138.392 347.086 320h-123.086l192 224 192-224h-128z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"rotate-cw",
				"cw",
				"arrow"
			],
			defaultCode: 60071,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 110,
			order: 2160,
			prevSize: 15,
			code: 60071,
			ligatures: "rotate-right",
			name: "rotate-right"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 114
	},
	{
		icon: {
			paths: [
				"M637.542 557.848c41.806-57.89 66.458-128.984 66.458-205.848 0-194.404-157.596-352-352-352s-352 157.596-352 352 157.596 352 352 352c76.864 0 147.958-24.652 205.848-66.458l338.152 386.458 128-128-386.458-338.152zM352 608c-141.384 0-256-114.616-256-256s114.616-256 256-256c141.382 0 256 114.616 256 256s-114.614 256-256 256z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"search"
			],
			defaultCode: 60208,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 111,
			order: 2161,
			ligatures: "search",
			prevSize: 15,
			code: 60208,
			name: "search"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 115
	},
	{
		icon: {
			paths: [
				"M879.326 195.908l-351.998-192c-4.774-2.606-10.048-3.908-15.322-3.908s-10.548 1.302-15.326 3.908l-352.004 192c-10.28 5.606-16.676 16.382-16.676 28.092v256c0 140.788 36.312 254.616 111.012 347.99 58.364 72.956 138.144 132.366 258.68 192.63 4.504 2.252 9.408 3.378 14.31 3.378s9.806-1.126 14.31-3.378c120.534-60.268 200.31-119.678 258.674-192.63 74.702-93.374 111.014-207.202 111.014-347.99l0.002-256c0-11.71-6.396-22.486-16.676-28.092zM800 480c0 60.998-7.508 114.184-22.954 162.598-14.868 46.606-36.792 87.632-67.022 125.422-44.742 55.928-106.512 103.48-198.022 152.008 0 0-0.002-0.002-0.002-0.002v-815.124l0.004-0.002 287.998 157.090-0.002 218.010z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"shield"
			],
			defaultCode: 60462,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 112,
			order: 2162,
			ligatures: "shield",
			prevSize: 15,
			code: 60462,
			name: "shield"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 116
	},
	{
		icon: {
			paths: [
				"M879.324 195.908l-351.996-192c-4.774-2.606-10.048-3.908-15.322-3.908-5.276 0-10.548 1.302-15.326 3.908l-352.004 192c-10.28 5.606-16.676 16.382-16.676 28.092v256c0 140.79 36.31 254.618 111.012 347.99 58.364 72.956 138.144 132.366 258.68 192.628 4.504 2.252 9.408 3.378 14.31 3.378s9.804-1.126 14.308-3.378c120.536-60.268 200.31-119.678 258.674-192.628 74.704-93.372 111.016-207.2 111.016-347.99l0.002-256c0-11.71-6.396-22.486-16.678-28.092zM416 722.912l-178.912-178.912 50.912-50.912 128 128 320-320 50.912 50.912-370.912 370.912z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"shield-check"
			],
			defaultCode: 60463,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 113,
			order: 2163,
			ligatures: "shield-check",
			prevSize: 15,
			code: 60463,
			name: "shield-check"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 117
	},
	{
		icon: {
			paths: [
				"M576 448h416l-160-160 192-192-96-96-192 192-160-160z",
				"M576 576v416l160-160 192 192 96-96-192-192 160-160z",
				"M448 575.996h-416l160 160-192 192 96 96 192-192 160 160z",
				"M448 448v-416l-160 160-192-192-96 96 192 192-160 160z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"shrink",
				"collapse",
				"minimize",
				"contract"
			],
			defaultCode: 60220,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			order: 2164,
			id: 114,
			prevSize: 15,
			code: 60220,
			ligatures: "shrink",
			name: "shrink"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 118
	},
	{
		icon: {
			paths: [
				"M384 256v704h-128v-704h-160l224-224 224 224zM640 768v-704h128v704h160l-224 224-224-224z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"sort"
			],
			defaultCode: 61000,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 115,
			order: 2165,
			ligatures: "sort",
			prevSize: 15,
			code: 61000,
			name: "sort"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 119
	},
	{
		icon: {
			paths: [
				"M704 0l-320 320h-192v384l512-512zM954.176 69.824l-884.352 884.352 69.824 69.824 282.176-282.176 282.176 282.176v-564.354l320-320z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"volume-mute",
				"volume",
				"audio",
				"speaker",
				"player"
			],
			defaultCode: 60836,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 116,
			order: 2166,
			prevSize: 15,
			code: 60836,
			ligatures: "sound-off",
			name: "sound-off"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 120
	},
	{
		icon: {
			paths: [
				"M719.53 831.53c-12.286 0-24.566-4.686-33.942-14.056-18.744-18.744-18.744-49.136 0-67.882 131.006-131.006 131.006-344.17 0-475.176-18.744-18.746-18.744-49.138 0-67.882 18.744-18.742 49.138-18.744 67.882 0 81.594 81.59 126.53 190.074 126.53 305.466 0 115.39-44.936 223.876-126.53 305.47-9.372 9.374-21.656 14.060-33.94 14.060v0zM549.020 741.020c-12.286 0-24.566-4.686-33.942-14.058-18.746-18.746-18.746-49.134 0-67.88 81.1-81.1 81.1-213.058 0-294.156-18.746-18.746-18.746-49.138 0-67.882s49.136-18.744 67.882 0c118.53 118.53 118.53 311.392 0 429.922-9.372 9.368-21.656 14.054-33.94 14.054z",
				"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"volume-medium",
				"volume",
				"audio",
				"speaker",
				"player"
			],
			defaultCode: 60813,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 117,
			order: 2167,
			prevSize: 15,
			code: 60813,
			ligatures: "sound-on",
			name: "sound-on"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 121
	},
	{
		icon: {
			paths: [
				"M1024 512c-1.278-66.862-15.784-133.516-42.576-194.462-26.704-61-65.462-116.258-113.042-161.92-47.552-45.696-103.944-81.82-164.984-105.652-61.004-23.924-126.596-35.352-191.398-33.966-64.81 1.282-129.332 15.374-188.334 41.356-59.048 25.896-112.542 63.47-156.734 109.576-44.224 46.082-79.16 100.708-102.186 159.798-23.114 59.062-34.128 122.52-32.746 185.27 1.286 62.76 14.964 125.148 40.134 182.206 25.088 57.1 61.476 108.828 106.11 151.548 44.61 42.754 97.472 76.504 154.614 98.72 57.118 22.304 118.446 32.902 179.142 31.526 60.708-1.29 120.962-14.554 176.076-38.914 55.15-24.282 105.116-59.48 146.366-102.644 41.282-43.14 73.844-94.236 95.254-149.43 13.034-33.458 21.88-68.4 26.542-103.798 1.246 0.072 2.498 0.12 3.762 0.12 35.346 0 64-28.652 64-64 0-1.796-0.094-3.572-0.238-5.332h0.238zM922.306 681.948c-23.472 53.202-57.484 101.4-99.178 141.18-41.67 39.81-91 71.186-144.244 91.79-53.228 20.678-110.29 30.452-166.884 29.082-56.604-1.298-112.596-13.736-163.82-36.474-51.25-22.666-97.684-55.49-135.994-95.712-38.338-40.198-68.528-87.764-88.322-139.058-19.87-51.284-29.228-106.214-27.864-160.756 1.302-54.552 13.328-108.412 35.254-157.69 21.858-49.3 53.498-93.97 92.246-130.81 38.73-36.868 84.53-65.87 133.874-84.856 49.338-19.060 102.136-28.006 154.626-26.644 52.5 1.306 104.228 12.918 151.562 34.034 47.352 21.050 90.256 51.502 125.624 88.782 35.396 37.258 63.21 81.294 81.39 128.688 18.248 47.392 26.782 98.058 25.424 148.496h0.238c-0.144 1.76-0.238 3.536-0.238 5.332 0 33.012 24.992 60.174 57.086 63.624-6.224 34.822-16.53 68.818-30.78 100.992z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"spinner",
				"loading",
				"loading-wheel",
				"busy",
				"wait"
			],
			defaultCode: 60192,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 118,
			order: 2168,
			prevSize: 15,
			code: 60192,
			ligatures: "spinner",
			name: "spinner"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 122
	},
	{
		icon: {
			paths: [
				"M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538zM512 753.498l-223.462 117.48 42.676-248.83-180.786-176.222 249.84-36.304 111.732-226.396 111.736 226.396 249.836 36.304-180.788 176.222 42.678 248.83-223.462-117.48z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"star-empty"
			],
			defaultCode: 60643,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 119,
			order: 2169,
			ligatures: "star-empty",
			prevSize: 15,
			code: 60643,
			name: "star-empty"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 123
	},
	{
		icon: {
			paths: [
				"M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"star-full"
			],
			defaultCode: 60645,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 120,
			order: 2170,
			ligatures: "star-full",
			prevSize: 15,
			code: 60645,
			name: "star-full"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 124
	},
	{
		icon: {
			paths: [
				"M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538zM512 753.498l-0.942 0.496 0.942-570.768 111.736 226.396 249.836 36.304-180.788 176.222 42.678 248.83-223.462-117.48z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"star-half"
			],
			defaultCode: 60644,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 121,
			order: 2171,
			ligatures: "star-half",
			prevSize: 15,
			code: 60644,
			name: "star-half"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 125
	},
	{
		icon: {
			paths: [
				"M512.002 193.212v-65.212h128v-64c0-35.346-28.654-64-64.002-64h-191.998c-35.346 0-64 28.654-64 64v64h128v65.212c-214.798 16.338-384 195.802-384 414.788 0 229.75 186.25 416 416 416 229.75 0 416-186.25 416-416 0-218.984-169.202-398.448-384-414.788zM706.276 834.274c-60.442 60.44-140.798 93.726-226.274 93.726s-165.834-33.286-226.274-93.726c-60.44-60.44-93.726-140.8-93.726-226.274s33.286-165.834 93.726-226.274c58.040-58.038 134.448-91.018 216.114-93.548l-21.678 314.020c-1.86 26.29 12.464 37.802 31.836 37.802s33.698-11.512 31.836-37.802l-21.676-314.022c81.666 2.532 158.076 35.512 216.116 93.55 60.44 60.44 93.726 140.8 93.726 226.274s-33.286 165.834-93.726 226.274z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"stopwatch",
				"time",
				"speed",
				"meter",
				"chronometer"
			],
			defaultCode: 59998,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 122,
			order: 2172,
			prevSize: 15,
			code: 59998,
			ligatures: "stopwatch",
			name: "stopwatch"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 126
	},
	{
		icon: {
			paths: [
				"M832 448c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128zM512 448c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128zM192 448c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"three-dots-horizontal"
			],
			defaultCode: 60519,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 123,
			order: 2173,
			ligatures: "three-dots-horizontal",
			prevSize: 15,
			code: 60519,
			name: "three-dots-horizontal"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 127
	},
	{
		icon: {
			paths: [
				"M384 192c0-70.692 57.308-128 128-128 70.692 0 128 57.308 128 128 0 70.692-57.308 128-128 128-70.692 0-128-57.308-128-128zM384 512c0-70.692 57.308-128 128-128 70.692 0 128 57.308 128 128 0 70.692-57.308 128-128 128-70.692 0-128-57.308-128-128zM384 832c0-70.692 57.308-128 128-128 70.692 0 128 57.308 128 128 0 70.692-57.308 128-128 128-70.692 0-128-57.308-128-128z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"more",
				"dots",
				"menu"
			],
			defaultCode: 60505,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 124,
			order: 2174,
			prevSize: 15,
			code: 60505,
			ligatures: "three-dots-vertical",
			name: "three-dots-vertical"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 128
	},
	{
		icon: {
			paths: [
				"M192 1024h640l64-704h-768zM640 128v-128h-256v128h-320v192l64-64h768l64 64v-192h-320zM576 128h-128v-64h128v64z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"bin",
				"trashcan",
				"remove",
				"delete",
				"recycle",
				"dispose"
			],
			defaultCode: 60411,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 125,
			order: 2175,
			prevSize: 15,
			code: 60411,
			ligatures: "trash",
			name: "trash"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 129
	},
	{
		icon: {
			paths: [
				"M224 384l288 288 288-288h-576z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"triangle-down"
			],
			defaultCode: 60870,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 126,
			order: 2187,
			ligatures: "triangle-down",
			prevSize: 15,
			code: 60870,
			name: "triangle-down"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 130
	},
	{
		icon: {
			paths: [
				"M640 224l-288 288 288 288v-576z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"triangle-left"
			],
			defaultCode: 60871,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 127,
			order: 2188,
			ligatures: "triangle-left",
			prevSize: 15,
			code: 60871,
			name: "triangle-left"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 131
	},
	{
		icon: {
			paths: [
				"M384 800l288-288-288-288v576z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"triangle-right"
			],
			defaultCode: 60869,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 128,
			order: 2186,
			ligatures: "triangle-right",
			prevSize: 15,
			code: 60869,
			name: "triangle-right"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 132
	},
	{
		icon: {
			paths: [
				"M800 640l-288-288-288 288h576z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"triangle-up"
			],
			defaultCode: 60868,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 129,
			order: 2185,
			ligatures: "triangle-up",
			prevSize: 15,
			code: 60868,
			name: "triangle-up"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 133
	},
	{
		icon: {
			paths: [
				"M1024 576l-128-256h-192v-128c0-35.2-28.8-64-64-64h-576c-35.2 0-64 28.8-64 64v512l64 64h81.166c-10.898 18.832-17.166 40.678-17.166 64 0 70.692 57.308 128 128 128s128-57.308 128-128c0-23.322-6.268-45.168-17.166-64h354.334c-10.898 18.832-17.168 40.678-17.168 64 0 70.692 57.308 128 128 128s128-57.308 128-128c0-23.322-6.27-45.168-17.168-64h81.168v-192zM704 576v-192h132.668l96 192h-228.668z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"truck"
			],
			defaultCode: 60428,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 130,
			order: 2193,
			ligatures: "truck",
			prevSize: 15,
			code: 60428,
			name: "truck"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 134
	},
	{
		icon: {
			paths: [
				"M440.236 635.766c-13.31 0-26.616-5.076-36.77-15.23-95.134-95.136-95.134-249.934 0-345.070l192-192c46.088-46.086 107.36-71.466 172.534-71.466s126.448 25.38 172.536 71.464c95.132 95.136 95.132 249.934 0 345.070l-87.766 87.766c-20.308 20.308-53.23 20.308-73.54 0-20.306-20.306-20.306-53.232 0-73.54l87.766-87.766c54.584-54.586 54.584-143.404 0-197.99-26.442-26.442-61.6-41.004-98.996-41.004s-72.552 14.562-98.996 41.006l-192 191.998c-54.586 54.586-54.586 143.406 0 197.992 20.308 20.306 20.306 53.232 0 73.54-10.15 10.152-23.462 15.23-36.768 15.23z",
				"M256 1012c-65.176 0-126.45-25.38-172.534-71.464-95.134-95.136-95.134-249.934 0-345.070l87.764-87.764c20.308-20.306 53.234-20.306 73.54 0 20.308 20.306 20.308 53.232 0 73.54l-87.764 87.764c-54.586 54.586-54.586 143.406 0 197.992 26.44 26.44 61.598 41.002 98.994 41.002s72.552-14.562 98.998-41.006l192-191.998c54.584-54.586 54.584-143.406 0-197.992-20.308-20.308-20.306-53.232 0-73.54 20.306-20.306 53.232-20.306 73.54 0.002 95.132 95.134 95.132 249.932 0.002 345.068l-192.002 192c-46.090 46.088-107.364 71.466-172.538 71.466z",
				"M928 832c-8.19 0-16.378-3.124-22.626-9.374l-128-128c-12.498-12.496-12.498-32.758 0-45.254 12.496-12.496 32.758-12.496 45.254 0l128 128c12.498 12.496 12.498 32.758 0 45.254-6.248 6.25-14.438 9.374-22.628 9.374z",
				"M992 640h-128c-17.674 0-32-14.326-32-32s14.326-32 32-32h128c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
				"M736 896c-17.674 0-32-14.326-32-32v-127.998c0-17.674 14.326-32 32-32s32 14.326 32 32v127.998c0 17.674-14.326 32-32 32z",
				"M160 448h-128c-17.672 0-32-14.328-32-32s14.328-32 32-32h128c17.672 0 32 14.328 32 32s-14.326 32-32 32z",
				"M224 384c-8.19 0-16.378-3.124-22.626-9.374l-128-128c-12.498-12.496-12.498-32.758 0-45.254 12.496-12.498 32.758-12.498 45.254 0l128 128c12.498 12.496 12.498 32.758 0 45.254-6.248 6.25-14.438 9.374-22.628 9.374z",
				"M288 320c-17.672 0-32-14.328-32-32v-128c0-17.672 14.328-32 32-32s32 14.328 32 32v128c0 17.672-14.326 32-32 32z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"unlink",
				"link",
				"break"
			],
			defaultCode: 60567,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 131,
			order: 2194,
			prevSize: 15,
			code: 60567,
			ligatures: "unlink",
			name: "unlink"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 135
	},
	{
		icon: {
			paths: [
				"M768 64c105.87 0 192 86.13 192 192v192h-128v-192c0-35.29-28.71-64-64-64h-128c-35.29 0-64 28.71-64 64v192h16c26.4 0 48 21.6 48 48v480c0 26.4-21.6 48-48 48h-544c-26.4 0-48-21.6-48-48v-480c0-26.4 21.6-48 48-48h400v-192c0-105.87 86.13-192 192-192h128z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"unlocked",
				"lock-open"
			],
			defaultCode: 60241,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 132,
			order: 2195,
			prevSize: 15,
			code: 60241,
			ligatures: "unlocked",
			name: "unlocked"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 136
	},
	{
		icon: {
			paths: [
				"M576 706.612v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h896c0-128.968-166.898-235.64-384-253.388z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"user"
			],
			defaultCode: 60148,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 133,
			order: 2196,
			ligatures: "user",
			prevSize: 15,
			code: 60148,
			name: "user"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 137
	},
	{
		icon: {
			paths: [
				"M384 736c0-151.234 95.874-280.486 230.032-330.2 16.28-36.538 25.968-77.164 25.968-117.8 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h397.306c-8.664-30.53-13.306-62.732-13.306-96z",
				"M736 448c-159.058 0-288 128.942-288 288s128.942 288 288 288c159.056 0 288-128.942 288-288s-128.942-288-288-288zM896 768h-128v128h-64v-128h-128v-64h128v-128h64v128h128v64z"
			],
			width: 1024,
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"user-plus",
				"user",
				"user-add",
				"profile",
				"avatar",
				"person",
				"member"
			],
			defaultCode: 60150,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 134,
			order: 2197,
			prevSize: 15,
			code: 60150,
			ligatures: "user-add",
			name: "user-add"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 138
	},
	{
		icon: {
			paths: [
				"M768 770.612v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h896c0-128.968-166.898-235.64-384-253.388z",
				"M327.196 795.328c55.31-36.15 124.080-63.636 199.788-80.414-15.054-17.784-28.708-37.622-40.492-59.020-30.414-55.234-46.492-116.058-46.492-175.894 0-86.042 0-167.31 30.6-233.762 29.706-64.504 83.128-104.496 159.222-119.488-16.914-76.48-61.94-126.75-181.822-126.75-192 0-192 128.942-192 288 0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h279.006c14.518-12.91 30.596-25.172 48.19-36.672z"
			],
			width: 1152,
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"users",
				"group",
				"team",
				"members",
				"community",
				"collaborate"
			],
			defaultCode: 60149,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 135,
			order: 2198,
			prevSize: 15,
			code: 60149,
			ligatures: "users",
			name: "users"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 139
	},
	{
		icon: {
			paths: [
				"M640 576c105.87 0 201.87 43.066 271.402 112.598l-90.468 90.468c-46.354-46.356-110.356-75.066-180.934-75.066s-134.578 28.71-180.934 75.066l-90.468-90.468c69.532-69.532 165.532-112.598 271.402-112.598zM187.452 507.452c120.88-120.88 281.598-187.452 452.548-187.452s331.668 66.572 452.55 187.452l-90.51 90.508c-96.706-96.704-225.28-149.96-362.040-149.96-136.762 0-265.334 53.256-362.038 149.962l-90.51-90.51zM988.784 134.438c106.702 45.132 202.516 109.728 284.782 191.996v0l-90.508 90.508c-145.056-145.056-337.92-224.942-543.058-224.942-205.14 0-398 79.886-543.058 224.942l-90.51-90.51c82.268-82.266 178.082-146.862 284.784-191.994 110.504-46.738 227.852-70.438 348.784-70.438 120.932 0 238.278 23.7 348.784 70.438zM576 896c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64z"
			],
			width: 1280,
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"connection",
				"wifi",
				"wave"
			],
			defaultCode: 59772,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			order: 2199,
			id: 136,
			prevSize: 15,
			code: 59772,
			ligatures: "wifi",
			name: "wifi"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 140
	},
	{
		icon: {
			paths: [
				"M384 192h-64v128h-128v64h128v128h64v-128h128v-64h-128zM637.542 557.848c41.806-57.89 66.458-128.984 66.458-205.848 0-194.404-157.596-352-352-352s-352 157.596-352 352 157.596 352 352 352c76.864 0 147.958-24.652 205.848-66.458l338.152 386.458 128-128-386.458-338.152zM352 608c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"zoom-in",
				"magnifier",
				"magnifier-plus",
				"enlarge"
			],
			defaultCode: 60209,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 137,
			order: 2200,
			prevSize: 15,
			code: 60209,
			ligatures: "zoom-in",
			name: "zoom-in"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 141
	},
	{
		icon: {
			paths: [
				"M192 320h320v64h-320zM637.542 557.848c41.806-57.89 66.458-128.984 66.458-205.848 0-194.404-157.596-352-352-352s-352 157.596-352 352 157.596 352 352 352c76.864 0 147.958-24.652 205.848-66.458l338.152 386.458 128-128-386.458-338.152zM352 608c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"zoom-out",
				"magnifier",
				"magnifier-minus",
				"reduce"
			],
			defaultCode: 60210,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 138,
			order: 2201,
			prevSize: 15,
			code: 60210,
			ligatures: "zoom-out",
			name: "zoom-out"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 142
	},
	{
		icon: {
			paths: [
				"M900 448h-868c-17.672 0-32 14.328-32 32 0 97.586 19.904 193.272 57.558 276.708 37.022 82.038 90.074 150.164 153.418 197.018 5.508 4.074 12.178 6.274 19.030 6.274h-134.006c-17.672 0-32 14.326-32 32s14.328 32 32 32h640c17.674 0 32-14.326 32-32s-14.326-32-32-32h-134.006c6.852 0 13.522-2.2 19.030-6.274 58.308-43.128 107.882-104.292 144.274-177.726h6.702c101.402 0 162.51-35.398 195.918-65.094 40.126-35.668 64.082-84.606 64.082-130.906 0-72.786-59.214-132-132-132zM920.082 657.094c-21.556 19.162-60.104 41.606-124.494 46.090 19.774-57.7 31.734-119.726 35.282-183.184h69.13c33.084 0 60 26.916 60 60 0 20.118-10.486 50.932-39.918 77.094z",
				"M288 384c-17.672 0-32-14.328-32-32v-128c0-17.672 14.328-32 32-32s32 14.328 32 32v128c0 17.672-14.326 32-32 32z",
				"M416 384c-17.672 0-32-14.328-32-32v-256c0-17.672 14.328-32 32-32s32 14.328 32 32v256c0 17.672-14.326 32-32 32z",
				"M544 384c-17.674 0-32-14.328-32-32v-128c0-17.672 14.326-32 32-32s32 14.328 32 32v128c0 17.672-14.326 32-32 32z"
			],
			width: 1088,
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"cup",
				"drink",
				"coffee",
				"break",
				"beverage",
				"hot",
				"breakfast"
			],
			defaultCode: 60358,
			grid: 16,
			colorPermutations: {
			}
		},
		attrs: [
		],
		properties: {
			id: 139,
			order: 2202,
			prevSize: 15,
			code: 60358,
			ligatures: "cup",
			name: "cup"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 143
	},
	{
		icon: {
			paths: [
				"M864 0h-832c-17.6 0-32 14.4-32 32v960c0 17.6 14.4 32 32 32h960c17.6 0 32-14.4 32-32v-832l-160-160zM256 32h512v256c0 17.6-14.4 32-32 32h-448c-17.6 0-32-14.4-32-32v-256zM896 992h-768v-416c0-35.348 28.654-64 64-64h640c35.346 0 64 28.652 64 64v416z",
				"M576 64h128v192h-128v-192z",
				"M256 576h512v64h-512v-64z",
				"M256 704h512v64h-512v-64z",
				"M256 832h512v64h-512v-64z"
			],
			attrs: [
			],
			isMulticolor: false,
			tags: [
				"floppy-disk",
				"save"
			],
			defaultCode: 60084,
			grid: 16
		},
		attrs: [
		],
		properties: {
			id: 140,
			order: 2203,
			prevSize: 15,
			code: 60084,
			ligatures: "floppy-disk, save2",
			name: "disk"
		},
		setIdx: 0,
		setId: 38,
		iconIdx: 144
	}
];
var height = 1024;
var metadata = {
	name: "prism-icon-font",
	designer: ""
};
var preferences = {
	showGlyphs: true,
	showQuickUse: true,
	showQuickUse2: true,
	showSVGs: true,
	fontPref: {
		prefix: "prism-icon-",
		metadata: {
			fontFamily: "prism-icon-font",
			majorVersion: 1,
			minorVersion: 6,
			designer: ""
		},
		metrics: {
			emSize: 1024,
			baseline: 6.25,
			whitespace: 50
		},
		ie7: false,
		includeMetadata: true,
		embed: true,
		showSelector: true,
		showMetrics: true,
		showVersion: true,
		showMetadata: false,
		cssVars: true,
		autoHost: true,
		resetPoint: 58880,
		noie8: true,
		selector: "class",
		classSelector: ".icon",
		cssVarsFormat: "scss",
		postfix: ""
	},
	imagePref: {
		prefix: "manheim-icon-",
		png: true,
		useClassSelector: true,
		color: 4868682,
		bgColor: 16777215,
		classSelector: ".icon",
		height: 16,
		columns: 16,
		margin: 16,
		postfix: "",
		minifyJs: false,
		pdf: false,
		name: "manheim-icons",
		addBgColor: false,
		sprite: false,
		overrideSize: true,
		xaml: true
	},
	historySize: 100,
	showCodes: true,
	gridSize: 16,
	quickUsageToken: {
		"Prism-UIONLY": false
	},
	showLiga: false,
	showGrid: true
};
var IconSelection = {
	IcoMoonType: IcoMoonType,
	icons: icons,
	height: height,
	metadata: metadata,
	preferences: preferences
};

function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}
var targetPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, DOMElement, PropTypes.shape({
  current: PropTypes.any
})]);
var tagPropType = PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.shape({
  $$typeof: PropTypes.symbol,
  render: PropTypes.func
}), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.shape({
  $$typeof: PropTypes.symbol,
  render: PropTypes.func
})]))]);

var uuid = function uuid(a) {
  return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
};

var propTypes = {
  glyph: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  xmlns: PropTypes.string,
  path: PropTypes.string,
  title: PropTypes.string,
  svgClassName: PropTypes.string
};
var defaultProps = {
  height: '16px',
  viewBox: null,
  xmlns: 'http://www.w3.org/2000/svg',
  path: null,
  fill: '#000',
  className: ''
}; /// GATHER ICONS

var iconSet = {};
IconSelection.icons.forEach(function (iconObj) {
  iconSet[iconObj.properties.name] = {
    paths: iconObj.icon.paths,
    width: iconObj.icon.width
  };
});

var getColorAtIndex = function getColorAtIndex(colors, index) {
  if (!Array.isArray(colors)) {
    return colors;
  } else {
    return colors[index % colors.length];
  }
};

var getColorAttr = function getColorAttr(colors, index) {
  var attrs = {};
  var c = getColorAtIndex(colors, index);

  if (!c) {
    attrs.style = {
      fill: 'inherit',
      color: 'inherit'
    };
  } else if (c.indexOf('#') === 0) {
    attrs.style = {
      fill: c
    };
  } else {
    attrs.className = "icon-".concat(c);
  }

  return attrs;
}; //////
//


function IconSvg(props) {
  var unique = uuid();

  var width = props.width,
      height = props.height,
      viewBox = props.viewBox,
      xmlns = props.xmlns,
      glyph = props.glyph,
      title = props.title,
      className = props.className,
      id = props.id,
      color = props.color,
      pathProps = _objectWithoutProperties(props, ["width", "height", "viewBox", "xmlns", "glyph", "title", "className", "id", "color"]);

  var svgProps = {
    width: width,
    height: height,
    viewBox: viewBox,
    xmlns: xmlns,
    className: className,
    id: id
  };
  var titleTag = title ? /*#__PURE__*/React.createElement("title", null, title) : null;
  svgProps.className = "prism-icon-svg ".concat(svgProps.className).trim();
  var paths = null;

  if (glyph && iconSet[glyph]) {
    var i = 0;
    paths = /*#__PURE__*/React.createElement(React.Fragment, null, iconSet[glyph].paths.map(function (d, index) {
      return /*#__PURE__*/React.createElement("path", _extends({
        d: d,
        key: "".concat(unique, "--").concat(i++)
      }, getColorAttr(color, index), pathProps));
    }));

    if (!viewBox) {
      svgProps.viewBox = "0 0 ".concat(iconSet[glyph].width || 1024, " 1024");
    } // ensure we maintain aspect ratio with the height


    if (!width) {
      var h = parseFloat(height, 10);
      var w = (iconSet[glyph].width || 1024) / 1024 * h + 'px';
      svgProps.width = w;
    }
  } else {
    paths = /*#__PURE__*/React.createElement("path", pathProps);
  }

  return /*#__PURE__*/React.createElement("svg", svgProps, titleTag, paths);
}

IconSvg.propTypes = propTypes;
IconSvg.defaultProps = defaultProps;

var propTypes$1 = Object.freeze({
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});
var defaultProps$1 = Object.freeze({
  color: '#000000',
  size: 'md'
});
var knownValues = Object.freeze({
  xs: 15,
  sm: 19,
  md: 25,
  lg: 33,
  xl: 47,
  xxl: 47
});
var oddifyAndStringifySize = function oddifyAndStringifySize(s) {
  if (!isNaN(+s)) {
    // this is necessary to find a center point of the spinner.
    return s % 2 === 1 ? "".concat(s, "px") : "".concat(s - 1, "px");
  } else {
    return '25px';
  }
};
var checkKnownValues = function checkKnownValues(s) {
  var sLower = s.toString().toLowerCase();
  return knownValues[sLower] || parseInt(s);
};
var processSize = function processSize(s) {
  return typeof s === 'number' ? oddifyAndStringifySize(s) : oddifyAndStringifySize(checkKnownValues(s));
};
var Spinner = function Spinner(_ref) {
  var color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconSvg, {
    className: "spinner",
    glyph: "spinner",
    color: color,
    height: processSize(size)
  }));
};
Spinner.propTypes = propTypes$1;
Spinner.defaultProps = defaultProps$1;

export default Spinner;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
